function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient",
  x1: 339,
  y1: 1264.85,
  x2: 413.7,
  y2: 1379.14,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-2",
  x1: 212.58,
  y1: 1262.19,
  x2: 372.28,
  y2: 1264.06,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#e5e9f5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#dce1f1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-3",
  x1: 377.37,
  y1: 1233.59,
  x2: 245.92,
  y2: 1125.94,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e8ecf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#e6eaf5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#d5dbee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-4",
  x1: 224.36,
  y1: 1201.93,
  x2: 392.08,
  y2: 1201.93,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-5",
  x1: 213.68,
  y1: 1166.98,
  x2: 373.55,
  y2: 1168.85,
  xlinkHref: "#hero_svg__linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-6",
  x1: 382.01,
  y1: 1175.17,
  x2: 265.68,
  y2: 1096.07,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-7",
  x1: 224.36,
  y1: 1149.97,
  x2: 392.08,
  y2: 1149.97,
  xlinkHref: "#hero_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-8",
  x1: 214.29,
  y1: 1115.02,
  x2: 374.16,
  y2: 1116.89,
  xlinkHref: "#hero_svg__linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-9",
  x1: 268.71,
  y1: 1021.17,
  x2: 418.38,
  y2: 1217.63,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-10",
  x1: 224.36,
  y1: 1098.01,
  x2: 392.08,
  y2: 1098.01,
  xlinkHref: "#hero_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-11",
  x1: 1484.43,
  y1: 1212.53,
  x2: 1500.75,
  y2: 1242.77,
  gradientTransform: "matrix(-1 0 0 1 1862.9 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8e9dcf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-12",
  x1: 363.21,
  y1: 1215.89,
  x2: 389.79,
  y2: 1270.77,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#edf1f8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#e0e5f3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-13",
  x1: 1509.89,
  y1: 1227.4,
  x2: 1526.2,
  y2: 1257.64,
  xlinkHref: "#hero_svg__linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-14",
  x1: 333.98,
  y1: 1230.28,
  x2: 372.13,
  y2: 1289.44,
  xlinkHref: "#hero_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-15",
  x1: 1484.43,
  y1: 1245.01,
  x2: 1500.75,
  y2: 1275.25,
  xlinkHref: "#hero_svg__linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-16",
  x1: 366.56,
  y1: 1257.55,
  x2: 388.43,
  y2: 1295.7,
  xlinkHref: "#hero_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-17",
  x1: 1509.89,
  y1: 1259.88,
  x2: 1526.2,
  y2: 1290.11,
  xlinkHref: "#hero_svg__linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-18",
  x1: 336.8,
  y1: 1267.61,
  x2: 361.24,
  y2: 1304.48,
  xlinkHref: "#hero_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-19",
  x1: 138.31,
  y1: 1406.99,
  x2: 140.45,
  y2: 1410.6,
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-20",
  x1: 127.77,
  y1: 1400.45,
  x2: 129.85,
  y2: 1403.97,
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-21",
  x1: 495.36,
  y1: 1652.2,
  x2: 516.72,
  y2: 1682.3,
  gradientTransform: "matrix(-1 0 0 1 723.5 -1276.45)",
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-22",
  x1: -625.81,
  y1: 1629.91,
  x2: -625.81,
  y2: 1423.17,
  gradientTransform: "translate(854.17 -1276.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#454fa1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#2c336e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#181c45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#101436"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-23",
  x1: 529.06,
  y1: 1516.52,
  x2: 445.36,
  y2: 1543.06,
  gradientTransform: "matrix(-1 0 0 1 723.5 -1276.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#27335c",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#31406b",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-24",
  x1: -586.01,
  y1: 1489.39,
  x2: -617.87,
  y2: 1516.01,
  gradientTransform: "translate(854.17 -1276.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-25",
  x1: 229.18,
  y1: 530.77,
  x2: 257.35,
  y2: 582.89,
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-26",
  x1: 137.99,
  y1: 424.56,
  x2: 194.66,
  y2: 636.13,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8e9dcf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-27",
  x1: 171.16,
  y1: 410.43,
  x2: 262.68,
  y2: 523.51,
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-28",
  x1: 53.23,
  y1: 444.77,
  x2: 84.47,
  y2: 579.85,
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-29",
  x1: 205.7,
  y1: 454.88,
  x2: 310.86,
  y2: 594.8,
  xlinkHref: "#hero_svg__linear-gradient-26"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-30",
  x1: 45.32,
  y1: 475,
  x2: 150.48,
  y2: 668.17,
  xlinkHref: "#hero_svg__linear-gradient-26"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-31",
  x1: 185.85,
  y1: 425.67,
  x2: 247.89,
  y2: 517.19,
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-32",
  x1: 24.02,
  y1: 413.58,
  x2: 106.75,
  y2: 615.55,
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-33",
  x1: 195.55,
  y1: 448.55,
  x2: 298.08,
  y2: 591.56,
  xlinkHref: "#hero_svg__linear-gradient-26"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-34",
  x1: 61.37,
  y1: 478.2,
  x2: 85.57,
  y2: 634.84,
  xlinkHref: "#hero_svg__linear-gradient-26"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-35",
  x1: 171.16,
  y1: 430.54,
  x2: 262.68,
  y2: 543.63,
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-36",
  x1: 53.23,
  y1: 464.88,
  x2: 84.47,
  y2: 599.97,
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-37",
  x1: 205.7,
  y1: 474.99,
  x2: 310.86,
  y2: 614.92,
  xlinkHref: "#hero_svg__linear-gradient-26"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-38",
  x1: 45.32,
  y1: 495.11,
  x2: 150.48,
  y2: 688.28,
  xlinkHref: "#hero_svg__linear-gradient-26"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-39",
  x1: 185.85,
  y1: 445.78,
  x2: 247.89,
  y2: 537.3,
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-40",
  x1: 24.02,
  y1: 433.7,
  x2: 106.75,
  y2: 635.67,
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-41",
  x1: 195.55,
  y1: 468.67,
  x2: 298.08,
  y2: 611.67,
  xlinkHref: "#hero_svg__linear-gradient-26"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-42",
  x1: 61.37,
  y1: 498.31,
  x2: 85.57,
  y2: 654.96,
  xlinkHref: "#hero_svg__linear-gradient-26"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-43",
  x1: 185.85,
  y1: 455.92,
  x2: 247.89,
  y2: 547.44,
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-44",
  x1: 24.02,
  y1: 443.84,
  x2: 106.75,
  y2: 645.81,
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-45",
  x1: 133.44,
  y1: 350.34,
  x2: 222.01,
  y2: 578.17,
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-46",
  x1: 189.11,
  y1: 650.02,
  x2: 136.45,
  y2: 771.8,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#5c71b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f7c963"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-47",
  x1: 133.48,
  y1: 728.15,
  x2: 148.93,
  y2: 749.77,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  xlinkHref: "#hero_svg__linear-gradient-23"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-48",
  x1: 206.58,
  y1: 572.32,
  x2: 175.41,
  y2: 715.01,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#7991bd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#396a85"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#105262"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#014955"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-49",
  x1: 175.01,
  y1: 565.42,
  x2: 143.84,
  y2: 708.11,
  xlinkHref: "#hero_svg__linear-gradient-48"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-50",
  x1: 149.16,
  y1: 701.36,
  x2: 95.55,
  y2: 668.43,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  xlinkHref: "#hero_svg__linear-gradient-23"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-51",
  x1: 165.18,
  y1: 712.98,
  x2: 160.82,
  y2: 656.29,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  xlinkHref: "#hero_svg__linear-gradient-23"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-52",
  x1: 158.64,
  y1: 689.62,
  x2: 141.26,
  y2: 689.62,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#94a2d2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#aab5db"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#bbc4e3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#c6cee8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#cdd4eb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-53",
  x1: 168,
  y1: 640.89,
  x2: 115.34,
  y2: 762.67,
  xlinkHref: "#hero_svg__linear-gradient-46"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-54",
  x1: 138.05,
  y1: 746.47,
  x2: 131.07,
  y2: 700.11,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  xlinkHref: "#hero_svg__linear-gradient-23"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-55",
  x1: 162.25,
  y1: 638.4,
  x2: 109.59,
  y2: 760.18,
  xlinkHref: "#hero_svg__linear-gradient-46"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-56",
  x1: 229.24,
  y1: 728.79,
  x2: 104.49,
  y2: 683.64,
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-57",
  x1: 157.06,
  y1: 738.8,
  x2: 172.98,
  y2: 715.59,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-58",
  x1: 595.18,
  y1: 882.16,
  x2: 622.83,
  y2: 835.28,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-59",
  x1: 385.31,
  y1: 886.36,
  x2: 574.7,
  y2: 886.36,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-60",
  x1: 452.39,
  y1: 1035.57,
  x2: 810.43,
  y2: 655.34,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-61",
  x1: 593.06,
  y1: 936.35,
  x2: 612.43,
  y2: 918.11,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-62",
  x1: 521.58,
  y1: 970.02,
  x2: 555.89,
  y2: 917.43,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-63",
  x1: 409.95,
  y1: 912.75,
  x2: 671.23,
  y2: 912.75,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-64",
  x1: 354.87,
  y1: 1201.14,
  x2: 657.58,
  y2: 931.96,
  gradientTransform: "matrix(1 0 0 -1 0 1189.14)",
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-65",
  x1: -391.8,
  y1: 1084.55,
  x2: -431.8,
  y2: 1064.1,
  gradientTransform: "rotate(180 72.52 594.57)",
  xlinkHref: "#hero_svg__linear-gradient-23"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-66",
  x1: 524.47,
  y1: 950.41,
  x2: 465.45,
  y2: 1117.65,
  gradientTransform: "matrix(1 0 0 -1 63.51 1189.14)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#7b85ab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#bbaf9c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#e4ca92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f3d48e"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-67",
  x1: -364.16,
  y1: 1048.06,
  x2: -437.37,
  y2: 983.39,
  gradientTransform: "rotate(180 72.52 594.57)",
  xlinkHref: "#hero_svg__linear-gradient-23"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-68",
  x1: 502.46,
  y1: 942.64,
  x2: 443.44,
  y2: 1109.88,
  xlinkHref: "#hero_svg__linear-gradient-66"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-69",
  x1: 492.79,
  y1: 1077.57,
  x2: 487.57,
  y2: 1051.96,
  gradientTransform: "matrix(1 0 0 -1 63.51 1189.14)",
  xlinkHref: "#hero_svg__linear-gradient-23"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-70",
  x1: -378.98,
  y1: 1087.51,
  x2: -403.53,
  y2: 1081.53,
  gradientTransform: "rotate(180 72.52 594.57)",
  xlinkHref: "#hero_svg__linear-gradient-23"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-71",
  x1: 450.97,
  y1: 1231.45,
  x2: 547.14,
  y2: 1034.85,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#007867"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#0b5d62"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#1c355c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#222659"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-72",
  x1: 488.46,
  y1: 1121.01,
  x2: 464.78,
  y2: 1137.46,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#141a3d",
  stopOpacity: 0.75
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#20294f",
  stopOpacity: 0.39
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#31406b",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-73",
  x1: 505.79,
  y1: 1151.86,
  x2: 484.85,
  y2: 1195.98,
  xlinkHref: "#hero_svg__linear-gradient-72"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-74",
  x1: 787.47,
  y1: 443.81,
  x2: 851,
  y2: 539.11,
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-75",
  x1: -139.56,
  y1: 451.83,
  x2: 176.97,
  y2: 451.83,
  gradientTransform: "translate(757.06)",
  xlinkHref: "#hero_svg__linear-gradient-59"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-76",
  x1: -288.63,
  y1: 409.62,
  x2: -46.68,
  y2: 388.61,
  gradientTransform: "translate(757.06)",
  xlinkHref: "#hero_svg__linear-gradient-59"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-77",
  x1: -189.08,
  y1: 431.19,
  x2: 96.08,
  y2: 431.19,
  gradientTransform: "translate(757.06)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#fff",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#fff",
  stopOpacity: 0.86
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#fff",
  stopOpacity: 0.97
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#fff",
  stopOpacity: 0.89
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#fff",
  stopOpacity: 0.76
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#fff",
  stopOpacity: 0.58
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.97,
  stopColor: "#fff",
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-78",
  x1: -158.18,
  y1: 465.56,
  x2: -87.3,
  y2: 464.94,
  gradientTransform: "translate(757.06)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-79",
  x1: -115.92,
  y1: 393.31,
  x2: 153.29,
  y2: 393.31,
  gradientTransform: "translate(757.06)",
  xlinkHref: "#hero_svg__linear-gradient-59"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-80",
  x1: -113.91,
  y1: 241.6,
  x2: 141.38,
  y2: 576.7,
  gradientTransform: "translate(757.06)",
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-81",
  x1: -189.08,
  y1: 372.67,
  x2: 96.08,
  y2: 372.67,
  xlinkHref: "#hero_svg__linear-gradient-77"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-82",
  x1: -158.18,
  y1: 407.04,
  x2: -87.3,
  y2: 406.42,
  xlinkHref: "#hero_svg__linear-gradient-78"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-83",
  x1: 753.34,
  y1: 342.28,
  x2: 768.32,
  y2: 364.25,
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-84",
  x1: 726.08,
  y1: 295.6,
  x2: 740.22,
  y2: 279.45,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#28335c",
  stopOpacity: 0.28
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#31406b",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-85",
  x1: 682.48,
  y1: 346.63,
  x2: 743.3,
  y2: 295.17,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2d327e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#262b6d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#161a45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#101436"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-86",
  x1: 747.51,
  y1: 318.21,
  x2: 809.63,
  y2: 291.45,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-87",
  x1: 692.45,
  y1: 295.96,
  x2: 716.66,
  y2: 289.14,
  xlinkHref: "#hero_svg__linear-gradient-84"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-88",
  x1: 690.5,
  y1: 356.11,
  x2: 751.31,
  y2: 304.65,
  xlinkHref: "#hero_svg__linear-gradient-85"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-89",
  x1: 727.04,
  y1: 332.58,
  x2: 711.05,
  y2: 332.58,
  gradientTransform: "rotate(-1.23 585.307 285.796)",
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-90",
  x1: 791.98,
  y1: 296.57,
  x2: 677.21,
  y2: 338.1,
  gradientTransform: "rotate(-1.23 585.307 285.796)",
  xlinkHref: "#hero_svg__linear-gradient-52"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-91",
  x1: 725.57,
  y1: 287.38,
  x2: 740.22,
  y2: 308.73,
  gradientTransform: "rotate(-1.23 585.307 285.796)",
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-92",
  x1: 823.36,
  y1: 625.91,
  x2: 924.85,
  y2: 786.6,
  gradientTransform: "matrix(1.39 -.05 -.05 1.45 -553.89 -376.21)",
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-93",
  x1: 606.95,
  y1: 1676.51,
  x2: 635.36,
  y2: 1779.07,
  gradientTransform: "translate(0 -1179.45)",
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-94",
  x1: 586.57,
  y1: 1519.11,
  x2: 631.71,
  y2: 1758.03,
  gradientTransform: "translate(0 -1179.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#014955"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#215b5c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#7a8e71"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#bbb481"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#e4cb8a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f3d48e"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-95",
  x1: 596.5,
  y1: 1504.71,
  x2: 599.77,
  y2: 1557.78,
  gradientTransform: "translate(0 -1179.45)",
  xlinkHref: "#hero_svg__linear-gradient-24"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-96",
  x1: 621.8,
  y1: 1565.36,
  x2: 587.58,
  y2: 1577.64,
  gradientTransform: "translate(0 -1179.45)",
  xlinkHref: "#hero_svg__linear-gradient-24"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-97",
  x1: 315.88,
  y1: 1223.87,
  x2: 698.46,
  y2: 1862.36,
  gradientTransform: "translate(0 -1179.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#aab5db"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.08,
  stopColor: "#bec7e5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#cbd2ea"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#d8deef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#bdc6e3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#a8b4da"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#99a7d4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#919fd0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8e9dcf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-98",
  x1: 264.72,
  y1: 1445.01,
  x2: 911.61,
  y2: 1765.32,
  gradientTransform: "translate(0 -1179.45)",
  xlinkHref: "#hero_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-99",
  x1: 245.66,
  y1: 1379.03,
  x2: 889.78,
  y2: 1865.97,
  gradientTransform: "translate(0 -1179.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8e9dcf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-100",
  x1: -148.61,
  y1: 1750.38,
  x2: -215.75,
  y2: 1663.02,
  gradientTransform: "matrix(-1 0 0 1 246.99 -1179.45)",
  xlinkHref: "#hero_svg__linear-gradient-99"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-101",
  x1: -116.3,
  y1: 1637.11,
  x2: -150.13,
  y2: 1592.81,
  gradientTransform: "matrix(-1 0 0 1 246.99 -1179.45)",
  xlinkHref: "#hero_svg__linear-gradient-99"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-102",
  x1: -116.3,
  y1: 1557.48,
  x2: -150.13,
  y2: 1513.18,
  gradientTransform: "matrix(-1 0 0 1 246.99 -1179.45)",
  xlinkHref: "#hero_svg__linear-gradient-99"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-103",
  x1: -108.27,
  y1: 1724.12,
  x2: -173.95,
  y2: 1502.52,
  gradientTransform: "matrix(-1 0 0 1 244.55 -1170.36)",
  xlinkHref: "#hero_svg__linear-gradient-99"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-104",
  x1: -222.31,
  y1: 1596.24,
  x2: -204.6,
  y2: 1633.42,
  gradientTransform: "matrix(-.59 -.01 .01 .62 268.45 -638.68)",
  xlinkHref: "#hero_svg__linear-gradient-99"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-105",
  x1: -309.75,
  y1: 1538.08,
  x2: -136.68,
  y2: 1538.08,
  gradientTransform: "matrix(-1 0 0 1 246.99 -1179.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-106",
  x1: -212.62,
  y1: 1519.25,
  x2: -260.04,
  y2: 1603.41,
  gradientTransform: "matrix(-1 0 0 1 246.99 -1179.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#007867"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#3eb883"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007867"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-107",
  x1: 457.08,
  y1: 1534.15,
  x2: 526.88,
  y2: 1705.49,
  gradientTransform: "translate(0 -1179.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#b6dec9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007867"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-108",
  x1: -253.28,
  y1: 1577.69,
  x2: -228.23,
  y2: 1577.69,
  gradientTransform: "matrix(-1 0 0 1 246.99 -1179.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-109",
  x1: -3470.09,
  y1: 52.78,
  x2: -3452.62,
  y2: 52.78,
  gradientTransform: "matrix(-1 -.09 -.09 1 -3078.95 -146.99)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#535a8b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#7980b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#878ec2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-110",
  x1: -3401.56,
  y1: 201.67,
  x2: -3362.41,
  y2: 239.83,
  gradientTransform: "matrix(-1 0 0 1 -3034.99 0)",
  xlinkHref: "#hero_svg__linear-gradient-109"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-111",
  x1: -3400.47,
  y1: 193.01,
  x2: -3403.73,
  y2: 229.98,
  gradientTransform: "matrix(-1 0 0 1 -3034.99 0)",
  xlinkHref: "#hero_svg__linear-gradient-109"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-112",
  x1: -3755.48,
  y1: 715.87,
  x2: -3747.87,
  y2: 682.59,
  gradientTransform: "matrix(-.99 .13 .13 .99 -3450.35 -14.34)",
  xlinkHref: "#hero_svg__linear-gradient-109"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-113",
  x1: -3735.35,
  y1: 697.68,
  x2: -3716.1,
  y2: 697.68,
  gradientTransform: "matrix(-.99 .13 .13 .99 -3450.35 -14.34)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#313866",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-114",
  x1: -3755.59,
  y1: 684.45,
  x2: -3740.56,
  y2: 687.26,
  gradientTransform: "matrix(-.99 .13 .13 .99 -3450.35 -14.34)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#313866",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#313866",
  stopOpacity: 0.15
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#313866",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-115",
  x1: -3756.01,
  y1: 686.66,
  x2: -3740.97,
  y2: 689.46,
  xlinkHref: "#hero_svg__linear-gradient-114"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-116",
  x1: -3755.65,
  y1: 684.77,
  x2: -3740.62,
  y2: 687.57,
  xlinkHref: "#hero_svg__linear-gradient-114"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-117",
  x1: -3767.12,
  y1: 699.6,
  x2: -3779.34,
  y2: 676.15,
  xlinkHref: "#hero_svg__linear-gradient-113"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-118",
  x1: -3951.69,
  y1: 3181.86,
  x2: -3923.68,
  y2: 3181.86,
  gradientTransform: "matrix(-.67 .74 .74 .67 -4644.31 953.81)",
  xlinkHref: "#hero_svg__linear-gradient-113"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-119",
  x1: 710.45,
  y1: 651.28,
  x2: 756.51,
  y2: 724.21,
  gradientTransform: "matrix(1.39 -.05 -.05 1.45 -553.89 -376.21)",
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-120",
  x1: 320.23,
  y1: 1529.76,
  x2: 435.93,
  y2: 1529.76,
  gradientTransform: "translate(0 -969.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#f0f3f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#e9edf7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#dee3f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#d3daee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#d8def0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d1d8ed"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-121",
  x1: 359.66,
  y1: 1453.65,
  x2: 402.45,
  y2: 1566.96,
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-122",
  x1: 320.65,
  y1: 1520.31,
  x2: 435.51,
  y2: 1520.31,
  xlinkHref: "#hero_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-123",
  x1: 473.26,
  y1: 591.94,
  x2: 586.69,
  y2: 711.16,
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-124",
  x1: 395.68,
  y1: 1573.97,
  x2: 511.38,
  y2: 1573.97,
  xlinkHref: "#hero_svg__linear-gradient-120"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-125",
  x1: 435.11,
  y1: 1497.87,
  x2: 477.9,
  y2: 1611.17,
  xlinkHref: "#hero_svg__linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-126",
  x1: 396.1,
  y1: 1564.53,
  x2: 510.95,
  y2: 1564.53,
  xlinkHref: "#hero_svg__linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-127",
  x1: 348.42,
  y1: 582.93,
  x2: 359.68,
  y2: 619.79,
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-128",
  x1: 369.31,
  y1: 560.07,
  x2: 304.96,
  y2: 434.8,
  xlinkHref: "#hero_svg__linear-gradient-66"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-129",
  x1: 350.1,
  y1: 468.9,
  x2: 311.91,
  y2: 468.68,
  xlinkHref: "#hero_svg__linear-gradient-84"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-130",
  x1: 311.38,
  y1: 572.25,
  x2: 344.94,
  y2: 492.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#014955"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#143557"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#222659"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-131",
  x1: 342.44,
  y1: 497.72,
  x2: 287.18,
  y2: 520.69,
  xlinkHref: "#hero_svg__linear-gradient-84"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-132",
  x1: 377.52,
  y1: 561.69,
  x2: 332.47,
  y2: 431.17,
  xlinkHref: "#hero_svg__linear-gradient-130"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-133",
  x1: 352.23,
  y1: 483.66,
  x2: 306.8,
  y2: 494.96,
  xlinkHref: "#hero_svg__linear-gradient-84"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-134",
  x1: 382.49,
  y1: 551.81,
  x2: 318.25,
  y2: 426.75,
  xlinkHref: "#hero_svg__linear-gradient-66"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-136",
  x1: 368.25,
  y1: 446.77,
  x2: 336.39,
  y2: 482.93,
  xlinkHref: "#hero_svg__linear-gradient-84"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-137",
  x1: 392.62,
  y1: 558.39,
  x2: 346.71,
  y2: 425.39,
  xlinkHref: "#hero_svg__linear-gradient-130"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-138",
  x1: 393.67,
  y1: 546.21,
  x2: 329.32,
  y2: 420.93,
  xlinkHref: "#hero_svg__linear-gradient-66"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-139",
  x1: 352.92,
  y1: 391.63,
  x2: 352.67,
  y2: 445.99,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3eb883"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#399e7c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#2d5e69"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#25355d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#222659"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-140",
  x1: 340.4,
  y1: 391.57,
  x2: 340.14,
  y2: 445.93,
  xlinkHref: "#hero_svg__linear-gradient-139"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-141",
  x1: -5978.13,
  y1: 1594.17,
  x2: -5981.68,
  y2: 1554.7,
  gradientTransform: "translate(6733.27 -1179.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#535a8b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#7980b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#878ec2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-142",
  x1: -5990.13,
  y1: 1644.12,
  x2: -6027.69,
  y2: 1670.26,
  xlinkHref: "#hero_svg__linear-gradient-141"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-143",
  x1: 82.54,
  y1: 1654.61,
  x2: 147.45,
  y2: 1674.4,
  gradientTransform: "matrix(-1 0 0 1 862.12 -1179.45)",
  xlinkHref: "#hero_svg__linear-gradient-141"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-144",
  x1: 89.01,
  y1: 1633.4,
  x2: 153.91,
  y2: 1653.19,
  gradientTransform: "matrix(-1 0 0 1 862.12 -1179.45)",
  xlinkHref: "#hero_svg__linear-gradient-141"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-145",
  x1: -11649.38,
  y1: 5378.79,
  x2: -11688.15,
  y2: 5345.41,
  gradientTransform: "rotate(15.12 13224.624 49599.718)",
  xlinkHref: "#hero_svg__linear-gradient-141"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-146",
  x1: -11641.1,
  y1: 5398.74,
  x2: -11619.24,
  y2: 5344.89,
  gradientTransform: "rotate(15.12 13224.624 49599.718)",
  xlinkHref: "#hero_svg__linear-gradient-141"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-147",
  x1: -12466.32,
  y1: 3496.83,
  x2: -12444.46,
  y2: 3442.97,
  gradientTransform: "rotate(8.1 13193.27 89917.049)",
  xlinkHref: "#hero_svg__linear-gradient-141"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-148",
  x1: 9043.73,
  y1: 2167.65,
  x2: 9030.73,
  y2: 2142.72,
  gradientTransform: "matrix(-.95 -.32 -.32 .95 10032.93 1291.92)",
  xlinkHref: "#hero_svg__linear-gradient-113"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-149",
  x1: 14201.77,
  y1: 933.69,
  x2: 14217.62,
  y2: 933.69,
  gradientTransform: "matrix(-.86 -.22 -.2 .98 11581.13 2222.82)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#313866",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#313866",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-150",
  x1: 14201.77,
  y1: 935.7,
  x2: 14217.62,
  y2: 935.7,
  xlinkHref: "#hero_svg__linear-gradient-149"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-151",
  x1: 14201.77,
  y1: 933.07,
  x2: 14217.62,
  y2: 933.07,
  xlinkHref: "#hero_svg__linear-gradient-149"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-152",
  x1: 95.53,
  y1: 1602,
  x2: 167.41,
  y2: 1623.91,
  gradientTransform: "matrix(-1 0 0 1 862.12 -1179.45)",
  xlinkHref: "#hero_svg__linear-gradient-141"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-153",
  x1: 141.06,
  y1: 612.63,
  x2: 243.99,
  y2: 745.35,
  gradientTransform: "translate(541.31)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-154",
  x1: -70.91,
  y1: 593.19,
  x2: 285.88,
  y2: 593.19,
  gradientTransform: "translate(541.31)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#92a0d1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#bbc5e2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#d9dfef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#ebeff7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#c8d0e8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8e9dcf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-155",
  x1: 66.91,
  y1: 548.96,
  x2: 214.27,
  y2: 548.96,
  gradientTransform: "translate(541.31)",
  xlinkHref: "#hero_svg__linear-gradient-77"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-156",
  x1: 280.82,
  y1: 521.31,
  x2: 34.9,
  y2: 521.31,
  gradientTransform: "rotate(89.67 410.201 793.505)",
  xlinkHref: "#hero_svg__linear-gradient-154"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-157",
  x1: 54,
  y1: 498.99,
  x2: 225.3,
  y2: 557.96,
  gradientTransform: "translate(541.31)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.08,
  stopColor: "#3eb883"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#45ba87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#59c193"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#7acba6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#a7d9c0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b6dec9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-158",
  x1: 872.5,
  y1: 993.72,
  x2: 914.7,
  y2: 993.72,
  gradientTransform: "rotate(56.5 1506.772 358.681)",
  xlinkHref: "#hero_svg__linear-gradient-141"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-159",
  x1: 952.92,
  y1: 954.85,
  x2: 901.84,
  y2: 994.84,
  gradientTransform: "rotate(56.5 1506.772 358.681)",
  xlinkHref: "#hero_svg__linear-gradient-141"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-160",
  x1: 865.04,
  y1: 1002.29,
  x2: 898.32,
  y2: 1002.29,
  gradientTransform: "rotate(56.5 1506.772 358.681)",
  xlinkHref: "#hero_svg__linear-gradient-141"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-161",
  x1: 1885.46,
  y1: 2176.14,
  x2: 1893.36,
  y2: 2141.65,
  gradientTransform: "rotate(-7 -15010.181 11607.692)",
  xlinkHref: "#hero_svg__linear-gradient-141"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-162",
  x1: 1906.25,
  y1: 2157.22,
  x2: 1926.21,
  y2: 2157.22,
  gradientTransform: "rotate(-7 -15010.181 11607.692)",
  xlinkHref: "#hero_svg__linear-gradient-113"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-163",
  x1: 1885.29,
  y1: 2143.5,
  x2: 1900.87,
  y2: 2146.41,
  gradientTransform: "rotate(-7 -15010.181 11607.692)",
  xlinkHref: "#hero_svg__linear-gradient-149"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-164",
  x1: 1884.87,
  y1: 2145.74,
  x2: 1900.45,
  y2: 2148.65,
  gradientTransform: "rotate(-7 -15010.181 11607.692)",
  xlinkHref: "#hero_svg__linear-gradient-149"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-165",
  x1: 1885.23,
  y1: 2143.83,
  x2: 1900.81,
  y2: 2146.74,
  gradientTransform: "rotate(-7 -15010.181 11607.692)",
  xlinkHref: "#hero_svg__linear-gradient-149"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-166",
  x1: 1873.4,
  y1: 2159.23,
  x2: 1860.73,
  y2: 2134.93,
  gradientTransform: "rotate(-7 -15010.181 11607.692)",
  xlinkHref: "#hero_svg__linear-gradient-113"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-167",
  x1: 754.64,
  y1: 1032.38,
  x2: 783.67,
  y2: 1032.38,
  gradientTransform: "rotate(32.9 2131.388 401.496)",
  xlinkHref: "#hero_svg__linear-gradient-113"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "hero_svg__radial-gradient",
  cx: 811.73,
  cy: 334.75,
  r: 12.96,
  gradientTransform: "matrix(.98 0 0 .98 -77.55 -63.43)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#28335c",
  stopOpacity: 0.28
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#31406b",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "hero_svg__radial-gradient-2",
  cx: 808.35,
  cy: 330.85,
  r: 11.81,
  gradientTransform: "rotate(-3.19 2541.797 1604.366) scale(.98 .49)",
  xlinkHref: "#hero_svg__radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "hero_svg__radial-gradient-3",
  cx: 231.39,
  cy: 718.95,
  r: 86.57,
  gradientTransform: "matrix(.98 0 0 .32 453.87 413.9)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "hero_svg__radial-gradient-4",
  cx: 231.2,
  cy: 596.83,
  r: 109.33,
  gradientTransform: "rotate(89.65 354.557 651.661) scale(.98 .54)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#9aa8d4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#b5bfe0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#ccd3ea"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#dde2f1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#e9edf6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#f0f3f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f2f5fa"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "hero_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M751.26 413.85c5.7-4 19.38-2.37 25.61 10.17 2 4-5.88 1.32-2.81 10 4.48 12.72-24.2 15.26-30.52 11.84-1.49-.79-5.61-13.59-2.45-16.84-1.14-3-.7-5 .26-6.58 1.14-2.01 7.46-6.92 9.91-8.59z",
  fill: "none"
})), /*#__PURE__*/React.createElement("style", null, ".hero_svg__cls-120{fill:none}.hero_svg__cls-9{fill:#5c71b3}.hero_svg__cls-22{fill:#2d327e}.hero_svg__cls-23{fill:#e5315a}.hero_svg__cls-24{fill:#faac18}.hero_svg__cls-27,.hero_svg__cls-83{fill:#454fa1}.hero_svg__cls-27{stroke:#454fa1;stroke-width:1.04px;stroke-miterlimit:10}.hero_svg__cls-28{fill:#8e9dcf}.hero_svg__cls-30{fill:#f7d5c6}.hero_svg__cls-31{fill:#222659}.hero_svg__cls-34{fill:#101436}.hero_svg__cls-120{stroke-linecap:round;stroke-linejoin:round}.hero_svg__cls-58{fill:#231f20}.hero_svg__cls-59{fill:#df1d39}.hero_svg__cls-60{fill:#f2f5fa}.hero_svg__cls-61{fill:#915620}.hero_svg__cls-74{fill:#5b3415}.hero_svg__cls-82{fill:#f3d48e}.hero_svg__cls-84{fill:#ec6977}.hero_svg__cls-91{fill:#d3b4a7}.hero_svg__cls-92{fill:#f2bfa5}.hero_svg__cls-96{fill:#bf9582}.hero_svg__cls-109{fill:#014955}.hero_svg__cls-110{fill:#007867}.hero_svg__cls-120{stroke:#5b3415;stroke-width:.64px}.hero_svg__cls-123{fill:#ddac7c}.hero_svg__cls-124{fill:#fabd27}.hero_svg__cls-125{fill:#a57e5b}.hero_svg__cls-139{fill:#f7c963}.hero_svg__cls-146{fill:#221f34}.hero_svg__cls-154{fill:#fff}.hero_svg__cls-155{fill:#313866}.hero_svg__cls-156{fill:#3eb883}.hero_svg__cls-157{fill:#7dc9a9}.hero_svg__cls-173{fill:url(#hero_svg__linear-gradient-134)}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M387.72 328.78l-86.19 49.89L406 439.14l86.2-49.89z",
  fill: "url(#hero_svg__linear-gradient)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M301.2 253.43l-77.42-46.11V331.9a4.75 4.75 0 002.47 4.22l74.95 43.33a14.84 14.84 0 0014.68 0l74.31-43.07a4.87 4.87 0 002.47-4.22V207.32l-76.78 46.11a14.79 14.79 0 01-14.68 0z",
  fill: "url(#hero_svg__linear-gradient-2)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M301.2 253.43l-76.19-44a2.44 2.44 0 010-4.22l75.54-43.65a14.79 14.79 0 0114.68 0l76.2 44a2.44 2.44 0 010 4.22l-75.55 43.65a14.79 14.79 0 01-14.68 0z",
  fill: "url(#hero_svg__linear-gradient-3)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M308.54 256.68a15.85 15.85 0 01-8-2.14l-76.19-44 1.3-2.27 76.19 44a13.28 13.28 0 0013.38 0l75.55-43.64 1.3 2.27-75.55 43.65a15.82 15.82 0 01-8 2.14z",
  fill: "url(#hero_svg__linear-gradient-4)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M301.2 201.47l-77.42-46.12v38a4.75 4.75 0 002.47 4.22l74.95 43.33a14.79 14.79 0 0014.68 0l74.31-43.07a4.87 4.87 0 002.47-4.22v-38.19l-76.78 46.12a15 15 0 01-14.68-.07z",
  fill: "url(#hero_svg__linear-gradient-5)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M301.2 201.47L225 157.5a2.45 2.45 0 010-4.23l75.54-43.65a14.84 14.84 0 0114.68 0l76.2 44a2.44 2.44 0 010 4.22l-75.55 43.65a14.79 14.79 0 01-14.67-.02z",
  fill: "url(#hero_svg__linear-gradient-6)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M308.54 204.72a15.86 15.86 0 01-8-2.15l-76.19-44 1.3-2.27 76.19 44a13.33 13.33 0 0013.38 0l75.55-43.65 1.3 2.27-75.55 43.65a15.83 15.83 0 01-8 2.15z",
  fill: "url(#hero_svg__linear-gradient-7)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-9",
  d: "M317.7 224.27l69.63-40.21v-3.31L317.7 221zm0-5.39l69.63-40.21v-3.31l-69.63 40.21z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M301.2 149.51l-77.42-46.12v38a4.76 4.76 0 002.47 4.22l74.95 43.32a14.79 14.79 0 0014.68 0l74.31-43.06a4.88 4.88 0 002.47-4.22v-38.2l-76.78 46.12a15 15 0 01-14.68-.06z",
  fill: "url(#hero_svg__linear-gradient-8)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M301.2 149.51l-76.19-44a2.44 2.44 0 010-4.22l75.54-43.65a14.79 14.79 0 0114.68 0l76.2 44a2.45 2.45 0 010 4.23l-75.55 43.65a14.84 14.84 0 01-14.68-.01z",
  fill: "url(#hero_svg__linear-gradient-9)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M308.54 152.75a15.85 15.85 0 01-8-2.14l-76.19-44 1.3-2.28 76.19 44a13.33 13.33 0 0013.38 0l75.55-43.65 1.3 2.27-75.55 43.65a15.82 15.82 0 01-8 2.14z",
  fill: "url(#hero_svg__linear-gradient-10)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-9",
  d: "M317.7 172.31l69.63-40.21v-3.31L317.7 169zm0-5.4l69.63-40.2v-3.32L317.7 163.6z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M308.54 137.68a11.87 11.87 0 01-6.1-1.62l-48-27.73a5.7 5.7 0 010-9.88l47.41-27.34a12.2 12.2 0 0112.28 0l48 27.73a5.7 5.7 0 010 9.88l-47.42 27.34a12.25 12.25 0 01-6.17 1.62zm-51.7-34.94a.8.8 0 00-.39.71.81.81 0 00.39.72l48 27.73a7.39 7.39 0 007.34 0l47.42-27.34a.83.83 0 00.39-.72.82.82 0 00-.39-.71l-48-27.74a7.39 7.39 0 00-7.34 0z",
  fill: "#cfd6ec"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M358.3 267.14a15.24 15.24 0 016.95-11.95c2-1.17 3.83-1.24 5.13-.39l8.12 4.61-9.68 16.95-8.44-4.8c-1.24-.65-2.08-2.21-2.08-4.42z",
  fill: "url(#hero_svg__linear-gradient-11)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M366.68 272c0 4.41 3.12 6.17 6.95 4a15.25 15.25 0 006.95-12c0-4.42-3.12-6.17-6.95-4a15.25 15.25 0 00-6.95 12z",
  fill: "url(#hero_svg__linear-gradient-12)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M332.84 282a15.22 15.22 0 017-11.95c2-1.17 3.83-1.23 5.13-.39l8.12 4.61-9.68 17-8.44-4.81c-1.3-.65-2.08-2.21-2.08-4.42z",
  fill: "url(#hero_svg__linear-gradient-13)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M341.22 286.82c0 4.42 3.11 6.17 6.95 4a15.24 15.24 0 006.95-11.95c0-4.42-3.12-6.17-6.95-4a15.21 15.21 0 00-6.95 11.95z",
  fill: "url(#hero_svg__linear-gradient-14)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M358.3 299.62a15.22 15.22 0 016.95-11.95c2-1.17 3.83-1.24 5.13-.39l8.12 4.61-9.68 16.95-8.44-4.84c-1.24-.65-2.08-2.2-2.08-4.41z",
  fill: "url(#hero_svg__linear-gradient-15)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M366.68 304.42c0 4.42 3.12 6.17 6.95 4a15.25 15.25 0 006.95-12c0-4.41-3.12-6.17-6.95-4a15.25 15.25 0 00-6.95 12z",
  fill: "url(#hero_svg__linear-gradient-16)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M332.84 314.49a15.21 15.21 0 017-11.95c2-1.17 3.83-1.23 5.13-.39l8.12 4.61-9.68 16.95-8.44-4.8c-1.3-.65-2.08-2.21-2.08-4.42z",
  fill: "url(#hero_svg__linear-gradient-17)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M341.22 319.3c0 4.41 3.11 6.17 6.95 4a15.24 15.24 0 006.95-11.95c0-4.42-3.12-6.17-6.95-4a15.19 15.19 0 00-6.95 11.95z",
  fill: "url(#hero_svg__linear-gradient-18)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-22",
  d: "M246.32 260.71V246l-8.45-5v14.68zm12.6 7.27V253.3l-8.45-5V263z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-23",
  d: "M271.52 275.26v-14.68l-8.44-5v14.68z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-22",
  d: "M284.12 282.47v-14.62l-8.44-5v14.68z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M246.32 280.2v-14.68l-8.45-5v14.68z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-22",
  d: "M258.92 287.47v-14.68l-8.45-5v14.68zm12.6 7.28v-14.68l-8.44-5v14.68z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M284.12 302v-14.66l-8.44-5V297z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-22",
  d: "M246.32 299.68V285l-8.45-5v14.68zm12.6 7.28v-14.68l-8.45-5V302z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M271.52 314.23v-14.68l-8.44-5v14.68z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-22",
  d: "M284.12 321.44v-14.61l-8.44-5v14.68zm-37.8-2.27v-14.68l-8.45-5v14.68zm12.6 7.27v-14.68l-8.45-5v14.68z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-23",
  d: "M271.52 333.72V319l-8.44-5v14.68zm12.6 7.21v-14.62l-8.44-5V336z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M58.46 494.66l-10-5.62 168.83-97.26a11.94 11.94 0 0112 0l3.36 2z",
  fill: "url(#hero_svg__linear-gradient-19)"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M61.15 480.31l-9.95-5.62 142.26-81.82a12 12 0 0112 0l3.36 2z",
  fill: "url(#hero_svg__linear-gradient-20)"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-27",
  d: "M83.44 470a5.49 5.49 0 005.49 0l165.9-95.86a12.93 12.93 0 0112.88 0L322 405.73a5.68 5.68 0 005.56 0l64.35-37.49a1.83 1.83 0 000-3.18l-12.09-7A12.79 12.79 0 01373.4 347v-47.82a.36.36 0 01.06-.24c9-20.58-.36-29.74-.49-29.86a.61.61 0 01.8-.92c.43.37 10.13 9.77.79 31.08v47.69a11.44 11.44 0 005.8 10l12.09 7a3 3 0 010 5.25l-64.35 37.46a6.69 6.69 0 01-6.78 0L267 375a11.67 11.67 0 00-11.66 0L89.48 470.88a5.11 5.11 0 01-3.23 1 6.63 6.63 0 01-3.36-.91"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-27",
  d: "M85.33 456a5.51 5.51 0 005.5 0l139.63-80.66a13 13 0 0112.89 0L297.63 407a5.61 5.61 0 005.55 0l41.16-24.06a11.65 11.65 0 005.74-10v-59.78a.45.45 0 01.06-.24c7.39-19.17-1-29.8-1.1-29.92a.65.65 0 01.06-.85.64.64 0 01.86.06c.36.42 9 11.23 1.34 31v59.65a12.84 12.84 0 01-6.3 11.07L303.8 408a6.74 6.74 0 01-6.78 0l-54.28-31.63a11.67 11.67 0 00-11.66 0L91.44 457a7 7 0 01-3.42.91 6.63 6.63 0 01-3.36-.91"
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-28",
  cx: 227.13,
  cy: 159.32,
  r: 4.37
});

var _ref38 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-28",
  cx: 232.19,
  cy: 157.71,
  r: 3.76
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M204.66 421.75l74.73-42.28-31-2.26-13.76-23.51-74.74 42.3z",
  fill: "url(#hero_svg__linear-gradient-21)"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-30",
  d: "M277.22 275.59a1.42 1.42 0 00.45 2l13.33 9.86a1.09 1.09 0 00.82.3 1.53 1.53 0 001.13-.6 1.51 1.51 0 00-.3-2l-4.88-3.6c.15 0 .22-.08.3-.08l6.91 5.11a1.09 1.09 0 00.82.3 1.53 1.53 0 001.13-.6 1.51 1.51 0 00-.3-2l-6-4.43c0-.07.08-.15.15-.22l7.74 5.7a1.09 1.09 0 00.82.3 1.53 1.53 0 001.13-.6 1.5 1.5 0 00-.3-2l-8.49-6.31v-.45l5.56 4.13a1.17 1.17 0 00.83.3 1.56 1.56 0 001.12-.6 1.51 1.51 0 00-.3-2l-7.36-5.41a3.55 3.55 0 01.53-.22 9.41 9.41 0 011.5-.15 1.58 1.58 0 001.28-.68 1.44 1.44 0 00-.08-1.35 3.19 3.19 0 00-1.12-.9 12.84 12.84 0 00-4.51-.68 3.43 3.43 0 00-.9-.08l-2.63-.22-.15-.08a1.4 1.4 0 00-1.88.15 2.85 2.85 0 00-.75.15 6.59 6.59 0 00-4.58 5.49 4.27 4.27 0 00-.08 1 1.65 1.65 0 00-1 .61z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-31",
  d: "M217 360.09s39.28-17 27.49-4.51c-13.67 14.65-25.17 20.73-32.9 19.6S207.74 360 207.74 360m45.37 5.56c-.38 6.91 5.7 6.91 5.7 6.91s30.65 2.7 19.61 7.81c-9.69 4.43-30.5 5.71-38.16 5.26a4 4 0 01-3.83-4.06v-10.65"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-30",
  d: "M229.82 178.47v13.37c0 2.1 2 3.68 4.36 3.53a3.5 3.5 0 003.3-3.31v-11.94"
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-30",
  cx: 235.3,
  cy: 170.13,
  r: 14.27
});

var _ref44 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-28",
  cx: 227.13,
  cy: 169.3,
  r: 8.94
});

var _ref45 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-28",
  cx: 228.43,
  cy: 176.63,
  rx: 7.66,
  ry: 7.23
});

var _ref46 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-28",
  cx: 226.49,
  cy: 162.26,
  r: 5.49
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M255.36 249.3v120.48c-10.07 10.59-20 2.25-20 2.25l-6.76-99.3a7.65 7.65 0 01-1.35.08l-1.66 85.77c-10 10.37-20.28 3.76-20.28 3.76l-4-109.06 4-18.78h22.76l-.15 5 23.51.38z",
  fill: "url(#hero_svg__linear-gradient-22)"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M205.11 261.16a58.92 58.92 0 0019.3 5.41c12.77 1.43 31-3.83 31-3.83V249.3l-3.76-9.39-23.51-.38.15-5h-22.81l-4 18.78.23 6a29.65 29.65 0 003.38 1.87z",
  fill: "url(#hero_svg__linear-gradient-23)"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-34",
  d: "M247.7 194a7.1 7.1 0 00-1.58-1.35c-3.53-2.1-8.71-2.85-12.62-4-3.45-1.06-7-2-10.44-3a10.29 10.29 0 00-11.34 4.28c-8.49 13.15-13.22 46.8-13.22 61.82 0 0 14.8 18.25 58.74 5.56 1.2-.38.9-5.41.9-6.24.07-5-.23-9.84-.53-14.79-.82-11.2-4-22.54-6.38-33.5-.68-2.71-1.5-6.39-3.53-8.72z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M258.14 251.1c.07-5-.23-9.84-.53-14.8-.82-11.19-4-22.53-6.38-33.5a26.17 26.17 0 00-2.11-6.68 11 11 0 00-1.42.3 12.78 12.78 0 00-9.24 8.94c-1.73 5.25-1.58 11-1.35 16.37.3 6.38 1 12.77 1.12 19.23.15 5.78.08 11.79-1.65 17.35a24.17 24.17 0 01-1.35 3.23 112.85 112.85 0 0022-4.21c1.21-.33.83-5.41.91-6.23z",
  fill: "url(#hero_svg__linear-gradient-24)"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-34",
  d: "M288.33 267a6.21 6.21 0 01.45 2.63c-.15 3.38-2.63 9.54-8.71 11.12-.9.22-38.91-30-44.47-78.12-.52-4.51 1.51-8.86 5.94-10s9.16 1.5 10 5.94c7.8 41.11 33.71 64.85 36.79 68.43z"
});

var _ref52 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-28",
  cx: 236.63,
  cy: 167.35,
  r: 4.9
});

var _ref53 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-28",
  cx: 238.02,
  cy: 172.44,
  r: 4.37
});

var _ref54 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-28",
  cx: 241.24,
  cy: 167.35,
  r: 3.76
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M216.59 407.57c-3.17 1.63-6.34 3.22-9.35 4.86q-15.8 8.58-31.66 17c-37.79 20.24-75.81 40.26-112.87 61.82C45.07 501.55 26 509.8 9.25 521.41L246.21 659 449.8 541.42z",
  fill: "url(#hero_svg__linear-gradient-25)"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M158.31 380.74c2.15 1.11 4.3 2.19 6.35 3.3q10.69 5.82 21.46 11.55c25.62 13.73 51.4 27.31 76.53 41.92 12 7 23.74 14.25 35.12 22.13l-159.54 91.57L.18 471.5z",
  fill: "url(#hero_svg__linear-gradient-26)"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-27)",
  d: "M341.56 434.5L138.23 551.21v5.01l203.33-116.7v-5.02z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-28)",
  d: "M138.23 551.21L.18 471.5v5.02l138.05 79.7v-5.01z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-29)",
  d: "M341.56 439.52l-203.33 116.7v5.02l203.33-116.71v-5.01z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-30)",
  d: "M138.23 556.22L.18 476.52v5.01l138.05 79.71v-5.02z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-31)",
  d: "M341.56 444.53L138.23 561.24v5.01l203.33-116.7v-5.02z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-32)",
  d: "M138.23 561.24L.18 481.53v5.02l138.05 79.7v-5.01z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-33)",
  d: "M341.56 449.55l-203.33 116.7v5.02l203.33-116.7v-5.02z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-34)",
  d: "M138.23 566.25L.18 486.55v5.02l138.05 79.7v-5.02z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-35)",
  d: "M341.56 454.62l-203.33 116.7v5.02l203.33-116.71v-5.01z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-36)",
  d: "M138.23 571.32L.18 491.62v5.01l138.05 79.71v-5.02z"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-37)",
  d: "M341.56 459.63L138.23 576.34v5.01l203.33-116.7v-5.02z"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-38)",
  d: "M138.23 576.34L.18 496.63v5.02l138.05 79.7v-5.01z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-39)",
  d: "M341.56 464.65l-203.33 116.7v5.02l203.33-116.7v-5.02z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-40)",
  d: "M138.23 581.35L.18 501.65v5.02l138.05 79.7v-5.02z"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-41)",
  d: "M341.56 469.67l-203.33 116.7v5.01l203.33-116.7v-5.01z"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-42)",
  d: "M138.23 586.37L.18 506.67v5.01l138.05 79.7v-5.01z"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-43)",
  d: "M341.56 474.79l-203.33 116.7v5.02L341.56 479.8v-5.01z"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-44)",
  d: "M138.23 591.49L.18 511.79v5.01l138.05 79.71v-5.02z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M203.33 354.8L28.47 455.16S12.74 465.64 0 458.29h.18l138 79.7c12.74 7.36 28.47-3.13 28.47-3.13L341.56 434.5z",
  fill: "url(#hero_svg__linear-gradient-45)"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M196.05 378.3l103.03 59.49m-115.04-52.55l103.03 59.48m-115.04-52.55l103.03 59.49M160.02 399.1l103.03 59.49m-115.04-52.55l103.03 59.48m-115.05-52.55l103.04 59.49m-115.05-52.55l103.04 59.48m-115.05-52.55l103.04 59.49M99.96 433.78L203 493.26M87.95 440.71l103.03 59.49M75.94 447.64l103.03 59.49M63.93 454.58l103.03 59.48",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#8e9dcf",
  strokeWidth: 2.51,
  fill: "none"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-58",
  d: "M167.44 565.24h14.42v23h-14.42z"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-59",
  d: "M199.35 609c6.23-3.57-17.49-24.84-17.49-24.84-3.29 4.26-14.42-.42-14.42-.42s-2.87 5.1-1.33 8.67c0 0 28.41 19.39 33.24 16.59z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-60",
  d: "M181 588.61c-.07 0-.07 0-.14-.07a.34.34 0 01-.14-.49 3.94 3.94 0 014.55-1.88.38.38 0 01.28.41.31.31 0 01-.42.21 3.28 3.28 0 00-3.78 1.54.36.36 0 01-.35.28zm2.66 2.52c-.07 0-.07 0-.14-.07a.34.34 0 01-.14-.49 3.93 3.93 0 014.54-1.89.38.38 0 01.28.42.31.31 0 01-.42.21 3.26 3.26 0 00-3.77 1.54.36.36 0 01-.35.28zm2.72 2.52c-.07 0-.07 0-.14-.07a.34.34 0 01-.14-.49 3.86 3.86 0 014.55-1.89.38.38 0 01.28.42.31.31 0 01-.42.21 3.27 3.27 0 00-3.78 1.54c-.14.21-.21.28-.35.28z"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-58",
  d: "M206.53 535.79l10.94-10 22.84 24.91-10.93 10z"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-61",
  d: "M140.25 447.18l11.12-6.9 20.43 33-11.12 6.9z"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M142.67 455.72s11.4.49 16.51-10.28c0 0-14.76-15.19-19.24-13.3-8.12 3.5 2.73 23.58 2.73 23.58z",
  fill: "url(#hero_svg__linear-gradient-46)"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M142.67 455.72s11.4.49 16.51-10.28c0 0-14.76-15.19-19.24-13.3-8.12 3.5 2.73 23.58 2.73 23.58z",
  fill: "url(#hero_svg__linear-gradient-47)"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M217.27 554.46l-30.66-32.12a31.47 31.47 0 00-11.05-7.55l-41-17.15v-28h22.88v13.44l33.31 13.57a23.42 23.42 0 018.19 5.6L236 541c-.07-.14-10.92 14.34-18.75 13.43z",
  fill: "url(#hero_svg__linear-gradient-48)"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M186 530c-.48-15.18-14.13-18.05-25.75-23.44-6.79-3.15-13.57-6.3-20.29-9.45v-13.46h-22.9c-.84 0-.21 19.66.21 21.55 1.75 7.7 6.71 9.66 13.29 12.67 6.79 3.14 13.51 6.29 20.3 9.37 13.5 6.3 12.31 6.3 12.31 31.7v19.18a27.06 27.06 0 0022.88-2.12c-.05-13.49.35-32.38-.05-46z",
  fill: "url(#hero_svg__linear-gradient-49)"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M153.09 509.19c.63-.49 1.26-.91 2-1.4l.21-.21c1-.7 2-1.33 2.94-2-6.08-2.8-12.17-5.67-18.19-8.47v-13.46h-22.92c-.35 0-.42 3.35-.42 7.41 3.91 1.61 7.69 3.57 11.75 4.9 1.33.42 2.59.84 3.85 1.33a18.7 18.7 0 011.82.63 29.38 29.38 0 015.39 3.15c.77.42 1.61.77 2.38 1.26a48.54 48.54 0 015.32 3.78.93.93 0 011-.14c1.78.7 3.2 2.03 4.87 3.22z",
  fill: "url(#hero_svg__linear-gradient-50)"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M194.66 498.62a21.71 21.71 0 00-4-2.1L157.36 483v-13.49h-22.88v28l26 16.73 34.22-15.61z",
  fill: "url(#hero_svg__linear-gradient-51)"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M130.42 496.66v-4l26.17 15.75a1.83 1.83 0 001.89 0l38-21.91v3.29a1.07 1.07 0 01-.49.84l-37.51 21.63a1.83 1.83 0 01-1.89 0l-25.68-14.76a.91.91 0 01-.49-.84z",
  fill: "url(#hero_svg__linear-gradient-52)"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M120.34 440s3.66-8.7 16.66-8.7c15.05 0 22.88 49.2 22.88 49.2s-17.21 13.85-38.21 9.86c-.77-.14-6.71-1.75-6.5-2.66 0-.14 4.54-32.47 4.54-32.47l.63-15.25z",
  fill: "url(#hero_svg__linear-gradient-53)"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M138.05 479.45a19.68 19.68 0 01-6-6.23 31.54 31.54 0 01-3.85-16.31 57.23 57.23 0 00-8.47-3.91l-.07 2.23s-4.54 32.33-4.54 32.47c-.21.84 5.73 2.45 6.5 2.66 10.29 2 19.6-.35 26.53-3.22-.84-.69-1.75-1.39-2.59-2.09a83.36 83.36 0 00-7.49-5.6z",
  fill: "url(#hero_svg__linear-gradient-54)"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-61",
  d: "M129.37 419.34v15.53a4.39 4.39 0 005 4.06 4.08 4.08 0 003.85-3.85v-13.93"
});

var _ref92 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-61",
  cx: 139.52,
  cy: 418.22,
  r: 13.79
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-31",
  d: "M136.58 416.12s15.33 15.25 22 .28c0 0 7-4.55 4.2-11.9a1.24 1.24 0 00-1.89-.56c-1.61 1.33-1.33 0-5.32-5.39s-38.27-11.76-33 17.22c0 0 2 11.61 6.37 11.19 0 0 3.08-14.48 7.7-10.84z"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-61",
  d: "M133.29 417s-4.06-2.24-4.69 2.72 4 5.95 5.53 3.71"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-28",
  d: "M195.92 486.72l-38.42 22.19-26.59-15.33a.92.92 0 010-1.61l38.42-22.18 26.59 15.4a.86.86 0 010 1.53z"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-31",
  d: "M139 493.93l32.26-18.68 18.5 10.75-32.26 18.57z"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-61",
  d: "M150.79 496.8l-32.26-17.56a8.58 8.58 0 01-4.41-7.91l1.47-23.44 12.38.77-1.19 19.66a2.11 2.11 0 001 2c5.25 2.87 20.3 11.27 22.89 12.18s5.45.35 8.18 0c1-.14 2.1-.14 2.66.63s-.07 2-.91 2.38a9.35 9.35 0 01-1.26.49 9.41 9.41 0 00-3 1.53 6.79 6.79 0 00-1.75 2.66c-1.26 2.17-2.58 4.41-3.84 6.65z"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M109.71 459s8.33 7.84 19.24 3c0 0 3.57-21.55-4.9-24.21S109.71 459 109.71 459z",
  fill: "url(#hero_svg__linear-gradient-55)"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-61",
  d: "M155.26 499.32a1.41 1.41 0 01-.77-.21l-8-4.62a1.54 1.54 0 011.54-2.66l8 4.62a1.52 1.52 0 01.56 2.1 1.5 1.5 0 01-1.33.77zm4.74-1.12a1.41 1.41 0 01-.77-.21l-8-4.62a1.53 1.53 0 011.53-2.66l8 4.62a1.52 1.52 0 01.56 2.1 1.44 1.44 0 01-1.32.77zm3.52-1.68a1.41 1.41 0 01-.77-.21l-8.89-5.11a1.54 1.54 0 011.54-2.66l8.89 5.11a1.52 1.52 0 01.56 2.1 1.42 1.42 0 01-1.33.77zm1.48-2.94a1.41 1.41 0 01-.77-.21l-8.89-5.11a1.53 1.53 0 111.54-2.65l8.89 5.1a1.52 1.52 0 01.56 2.1 1.5 1.5 0 01-1.33.77z"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M196.9 486.24L157.5 509v-36.76l39.89-23v36.16a1.07 1.07 0 01-.49.84z",
  fill: "url(#hero_svg__linear-gradient-56)"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M194.38 448l-38.91 22.46a1 1 0 00-.49.84V507a1.07 1.07 0 00.49.84l2 1.19V472.8a1.07 1.07 0 01.53-.8l39.4-22.74-2-1.19a.84.84 0 00-1.02-.07z",
  fill: "url(#hero_svg__linear-gradient-57)"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-59",
  d: "M235.46 567c-7.7-.28-9.38-10-9.38-10 7.07-2.38 11.27-9.58 11.27-9.58s15.39-10.36 26.31-8.47c9.94 1.68-28.2 28.06-28.2 28.06z"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-60",
  d: "M241.06 549.36a.26.26 0 01-.21-.07 3.55 3.55 0 01-1.19-4.06.36.36 0 01.63.35c0 .07-.77 1.54 1.05 3.22a.34.34 0 010 .49c-.14 0-.21.07-.28.07zm2.52-1.33a.26.26 0 01-.21-.07 3.55 3.55 0 01-1.19-4.06.36.36 0 11.63.35c0 .07-.77 1.54 1.05 3.22a.34.34 0 010 .49c-.07 0-.14.07-.28.07zm2.59-1.33a.26.26 0 01-.21-.07 3.55 3.55 0 01-1.19-4.06.36.36 0 11.63.35c0 .07-.7 1.54 1 3.22a.34.34 0 010 .49c-.07 0-.21.07-.28.07z"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-74",
  d: "M132.94 421.57a.33.33 0 01-.35-.35 2.77 2.77 0 00-.35-1.67 1.12 1.12 0 00-1.19-.56.33.33 0 11-.21-.63 1.79 1.79 0 012 .84 3.51 3.51 0 01.42 2 .33.33 0 01-.35.35z"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-74",
  d: "M130.91 420.87a.53.53 0 01-.28-.14.34.34 0 010-.49 2.17 2.17 0 012.24-.35.34.34 0 01.14.49c-.14.21-.28.28-.49.14a1.41 1.41 0 00-1.47.21.15.15 0 01-.14.14z"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M587.42 428.67l-101.83-58.93 168.77-97.47 101.75 59z",
  fill: "url(#hero_svg__linear-gradient-58)"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M507 253.19l-96.4 14.19V322a7.66 7.66 0 003.81 6.64l81.14 46.87a22.76 22.76 0 0022.9 0l148.12-85.61a7.65 7.65 0 003.82-6.64V227z",
  fill: "url(#hero_svg__linear-gradient-59)"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M495.59 318.68l-81.14-47c-5-2.9-5-7.63 0-10.53l148.08-85.49c6.34-3.67 16.64-3.67 22.9 0l81.14 47c5 2.9 5 7.63 0 10.53l-148.15 85.49c-6.19 3.66-16.49 3.66-22.83 0z",
  fill: "url(#hero_svg__linear-gradient-60)"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M603.14 269.75L589 261.81l9.08-10.15L616.5 262z",
  fill: "url(#hero_svg__linear-gradient-61)"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M522.61 300.21L460.25 264l103.43-59.69 62.44 36.1z",
  fill: "url(#hero_svg__linear-gradient-62)"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M507.12 323.26a24.06 24.06 0 01-12.21-3.26l-85-49.16 1.53-2.67 84.95 49.15a21.36 21.36 0 0021.37 0l151.9-87.78 1.53 2.68L519.33 320a24.28 24.28 0 01-12.21 3.26z",
  fill: "url(#hero_svg__linear-gradient-63)"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M534.14 133.58l-107.93 62.28a4.09 4.09 0 01-6.11-3.51V68.7a6.84 6.84 0 013.36-5.88L531.39.54a4.09 4.09 0 016.11 3.51v123.73a6.49 6.49 0 01-3.36 5.8z",
  fill: "url(#hero_svg__linear-gradient-64)"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-82",
  d: "M448.73 98.92l-14 8V73.13l14-8.1z"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M448.73 98.92l-14 8v67.25l14-8z"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-82",
  d: "M467.27 128.85l-14 8V62.36l14-8z"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M467.27 128.85l-14 8v26.56l14-8z"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-82",
  d: "M485.82 94.19l-14 8V51.68l14-8z"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M485.82 94.19l-14 8v50.53l14-8z"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-82",
  d: "M504.37 47.86l-13.89 8V41l13.89-8.09z"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M504.37 47.86l-13.89 8v86.17l13.89-8.03z"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-82",
  d: "M522.92 47.78L509 55.8V30.23l13.89-8z"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M522.92 47.78L509 55.8v75.49l13.89-8z"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-83",
  d: "M567.72 102.74c1.23 2.44 2.37 4.89 3.44 7.18 2.9 6 2.67 13 1.75 19.54-.61 3.89-1.75 15.57-6 17-4.8 1.6-6.87-7.56-8.54-10.46-3.82-6.64-5-13.36-5.42-21-.46-8.85-.39-17.71-.23-26.64 0-.84.07-1.83.76-2.29 2-1.37 7.86 6.26 8.93 7.71a63.32 63.32 0 015.31 8.96z"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-30",
  d: "M564.26 210.78l9.91-9.74 28.9 29.39-9.91 9.74z"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-84",
  d: "M596.2 223.42a18.37 18.37 0 01-3.59 5.34 20.07 20.07 0 01-6.19 4.5l6.87 7 9.93-9.77-7-7z"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M567.72 102.74c1.23 2.44 2.37 4.89 3.44 7.18 2.9 6 2.67 13 1.75 19.54-.61 3.89-1.75 15.57-6 17-4.8 1.6-6.87-7.56-8.54-10.46-3.82-6.64-5-13.36-5.42-21-.46-8.85-.39-17.71-.23-26.64 0-.84.07-1.83.76-2.29 2-1.37 7.86 6.26 8.93 7.71a63.32 63.32 0 015.31 8.96z",
  fill: "url(#hero_svg__linear-gradient-65)"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-30",
  d: "M532.16 252.86l2.17-48.73 13.88.62-2.21 48.73z"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-84",
  d: "M532.84 238.61l-.61 14.2 13.89.61.61-13.06c-4.73.92-9.84.54-13.89-1.75z"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M550.93 198.92c2 10.45 19.47 36.41 19.47 36.41 19.92-4.51 28.16-26.19 28.16-26.19a192.2 192.2 0 01-14.5-14.65c-5.65-6.72-4.58-23.43-4.58-23.43 1.07-35.57-11.91-48.93-11.91-48.93h-23.66",
  fill: "url(#hero_svg__linear-gradient-66)"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M579.71 208.53a53.41 53.41 0 01-10.71-21.9c-1.91-8-2.45-16.34-3.74-24.5a31.72 31.72 0 00-3.44-10.39 50.17 50.17 0 00-6.49-9c-3.28-3.74-6.87-7-10.45-10.46l6.1 66.64c2 10.45 19.47 36.48 19.47 36.48 11.06-2.52 18.54-10.3 23-16.71a32.51 32.51 0 01-13.66-10.16z",
  fill: "url(#hero_svg__linear-gradient-67)"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M533.76 123.58l-11.6 104.72s21.83 14 39.15 5.35l.77-73.66.15-5.73s3.51-8.62 3.43-14.58",
  fill: "url(#hero_svg__linear-gradient-68)"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M538 134.11a22.63 22.63 0 004.58 1.45c9.85 2.52 21.22-.53 30-5.34a31.53 31.53 0 00-5-8h-23.67l.61 6.71-10.76-5.42-.69 6c-.15 1.22 3 3.51 4 4.12.38.23.69.38 1 .53z",
  fill: "url(#hero_svg__linear-gradient-69)"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-83",
  d: "M533.6 103.5a95.91 95.91 0 00-2.6 21.3c0 6.87 8.7 7.33 13.82 7.56 8.54.38 16.94-1.22 24-6.41a4.24 4.24 0 001.3-1.3 4.83 4.83 0 00.15-3.13c-1.52-8-2.44-16.64-5.65-24.12-2.51-6.11-7.32-10.84-14.19-11.22-9.54-.54-14.51 7.33-16.34 15.65-.15.45-.3 1.06-.46 1.67z"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M532 118a27 27 0 008.47-4.05c4.81-3.66 8.55-9.16 5.88-15a20.74 20.74 0 00-7.1-8.31 23.27 23.27 0 00-5.19 11.06c-.15.61-.23 1.22-.38 1.83a121.88 121.88 0 00-2.29 14.66 2.67 2.67 0 00.61-.19z",
  fill: "url(#hero_svg__linear-gradient-70)"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-30",
  d: "M511.39 85.64a1.44 1.44 0 00.69-2l-2.29-4.89-3.59-12.34a1.5 1.5 0 00-1.83-1 3 3 0 00-.69.38l-3.35-7.25a1.5 1.5 0 10-2.75 1.22l2.29 5a1.55 1.55 0 00-1.61-.23 1.46 1.46 0 00-.84 1.68 1.53 1.53 0 00-1.6-.23 1.45 1.45 0 00-.84 1.68 1.51 1.51 0 00-2.36 1.76l11.67 25.08a1.4 1.4 0 001.45.84 1.34 1.34 0 00.54-.16 1.47 1.47 0 00.84-1.67 1.88 1.88 0 001.07.38 1.35 1.35 0 00.53-.16 1.47 1.47 0 00.84-1.67 1.91 1.91 0 001.07.38 1.35 1.35 0 00.53-.16 1.54 1.54 0 00.77-2l-2.29-5a2 2 0 001.75.3z"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-83",
  d: "M541.77 89.15a4 4 0 011.91.84 8 8 0 012.6 4.74c1.6 8.7-6.34 13.35-13.21 16a49.47 49.47 0 01-12.82 3.35A13.62 13.62 0 01510 110.6c-3.66-3.2-5.95-7.55-7.71-12.06l-7-17.63 14.81-7.25s8.54 22.34 10.15 23.28c3.66 2.21 10.61-3.36 13.66-4.88 2.37-1.3 5.27-3.36 7.86-2.91z"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-31",
  d: "M532.54 245.4s7.71 7.79 13.74 4c0 0 5.72 7.33 2 12.52s-35.87-8-35.87-12.52 20.13-4 20.13-4zm57-8.93s9 1.07 10.23-9.39c0 0 9.47 1 9.7 6.57s-14.35 30.3-20.31 28.24c-3.36-1.07-3.43-14.35.38-25.42z"
});

var _ref138 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-30",
  cx: 543.38,
  cy: 72.51,
  r: 12.59
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M581.7 85.9c-3.48-7.32-6.29-14.72-9.68-22a1.42 1.42 0 00-.08-.18 25.25 25.25 0 00-21.24-16c-9.84-1.07-22.06 3.51-21.45 15.19 0 .07.46 9.08 12.83 6.49 0 0 .28 2.25.72 5.38a68.65 68.65 0 00-2 11.53c-.54 7.41.53 17.44 7.45 22 5.08 3.25 13.65 5.71 19.62 6.38 3.57.4 7.37.22 10.49-1.52 4.46-2.41 6.87-7.63 7-12.67s-1.47-10.05-3.66-14.6z"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-30",
  d: "M541 70.38a5.74 5.74 0 011.68-1.61c1.6-.83 3.59-.76 4.2 1.15a6.62 6.62 0 01-.61 4.5c-.69 1.3-1.84 2.29-3.36 2a4.83 4.83 0 01-2.67-2.29"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-91",
  d: "M542.15 72.9H542a.38.38 0 01-.15-.54c1.3-2.82 2.9-2.44 3-2.44a.43.43 0 01.3.46.42.42 0 01-.46.3s-1.07-.15-2.06 2.06a1 1 0 01-.46.16z"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-91",
  d: "M544.29 72.82a.36.36 0 01-.38-.38 1.8 1.8 0 00-.53-1.22.36.36 0 010-.54.37.37 0 01.53 0 2.48 2.48 0 01.76 1.76c0 .15-.23.3-.38.38z"
});

var _ref143 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-92",
  cx: 486.27,
  cy: 132.19,
  r: 18.75
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-92",
  d: "M477.18 142.65l-2.52 12.91 14.21 3.81 3.4-14.2"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M500.31 168.3c.4 1 .65 1.86 1 2.76 4.63 15.42 4.55 31.24 3.65 47.15 0 0-21.5 21.74-51-5.28.24-3.41.73-6.82 1.22-10.22a157.38 157.38 0 015-22.89c2.52-8.36 5.84-16.63 10.95-23.78a8 8 0 012.11-2.51 4.94 4.94 0 013.74-.08 27.84 27.84 0 009.25 1.3 8.51 8.51 0 012.84-.17 7 7 0 012 1.06 17.06 17.06 0 013.89 3.41 31.9 31.9 0 015.28 9.25z",
  fill: "url(#hero_svg__linear-gradient-71)"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M470 159.53a14.37 14.37 0 007 2.2 17.38 17.38 0 006.08-1.3 68.88 68.88 0 017.14-2.92c.9-.25 1.79-.41 2.6-.57a11 11 0 00-1.54-1.14 7 7 0 00-2-1.05 8.25 8.25 0 00-2.84.16 26 26 0 01-9.25-1.3c-1.14-.32-2.68-.65-3.73.08a8.76 8.76 0 00-2.11 2.52c-.73 1-1.46 2.11-2.11 3.16a1.12 1.12 0 01.81.16z",
  fill: "url(#hero_svg__linear-gradient-72)"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M501.2 170.73a22.66 22.66 0 00-9.09 7c-3.49 4.55-3.49 10.39-2.68 15.83.9 5.76 2 11.6 2 17.44a41.83 41.83 0 01-2.76 15.18 32 32 0 0016.33-7.89c.9-16 1-31.73-3.65-47.15a1.39 1.39 0 01-.16-.41z",
  fill: "url(#hero_svg__linear-gradient-73)"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-34",
  d: "M489.11 109.3c4.22.57 15.26 3.57 16.39 4.47 1.79 1.29.41 4.7-.49 6.24a10.31 10.31 0 01-5.92 4.71c-1.78.57-3.73 1.06-4.95 2.44-1.62 1.78-1.22 5-3.16 6.49-.33.24-.73.4-1.06.65a5.38 5.38 0 00-1.78 2.43c-1.47 3.25-2 8.36-6 9.33a18.38 18.38 0 01-12.67-1.06 14.15 14.15 0 01-1.38-.81 11.26 11.26 0 01-4.06-7c-.56-2.76.08-5.44.57-8.2 1-5.84 3-11.77 7.87-15.5a21.14 21.14 0 0111.69-4.38 17.23 17.23 0 014.95.16z"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-92",
  d: "M492 131.54a4.25 4.25 0 00-4.14 1.54 5.59 5.59 0 002.44 8.6 4.68 4.68 0 005.19-1.38c2.35-2.68-.08-8-3.49-8.76z"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-96",
  d: "M494.14 137.79c-.16 0-.32-.17-.41-.33a3 3 0 00-1.38-2.11 3.54 3.54 0 00-2.59-.32.39.39 0 01-.25-.73 4.59 4.59 0 013.25.4 3.9 3.9 0 011.7 2.68c.17.16 0 .32-.32.41z"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-96",
  d: "M490 138.35c-.32-.08-.4-.24-.4-.48a3.35 3.35 0 011.29-2.28 3.3 3.3 0 012.2-.4.41.41 0 01-.17.81 2.5 2.5 0 00-1.54.24 2.54 2.54 0 00-1 1.71c-.05.24-.22.4-.38.4z"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-74)",
  d: "M827.7 586.08l-143.71-82.96 142.71-82.39 143.7 82.96-142.7 82.39z"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M698.54 466.93l-132-78.63v42.59a8.36 8.36 0 004.17 7.24L698.54 512a25.08 25.08 0 0025.08 0l126.8-73.48a8.35 8.35 0 004.17-7.23v-43l-131 78.63a25.08 25.08 0 01-25.05.01z",
  fill: "url(#hero_svg__linear-gradient-75)"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M698.54 466.93l-129.91-75a4.18 4.18 0 010-7.24l128.87-74.42a25.08 25.08 0 0125.08 0l129.92 75a4.19 4.19 0 010 7.24l-128.88 74.42a25.08 25.08 0 01-25.08 0z",
  fill: "url(#hero_svg__linear-gradient-76)"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M852.5 392.52l-128.88 74.41a25.08 25.08 0 01-25.08 0l-129.91-75",
  stroke: "url(#hero_svg__linear-gradient-77)",
  strokeWidth: 2.58,
  strokeMiterlimit: 10,
  fill: "none"
});

var _ref156 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 579.71,
  cy: 421.36,
  rx: 4.37,
  ry: 7.57,
  transform: "rotate(-30.35 579.638 421.323)"
});

var _ref157 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 597.08,
  cy: 431.39,
  rx: 4.37,
  ry: 7.57,
  transform: "rotate(-30.35 597.004 431.357)"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-78)",
  d: "M696.07 494.7l-81.32-46.95v-12.32l81.32 46.95v12.32z"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-9",
  d: "M726.73 494.7l118.69-68.52v-5.63l-118.69 68.52v5.63zm0-9.2l118.69-68.52v-5.62l-118.69 68.51v5.63z"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M698.54 408.41l-132-78.63v42.59a8.36 8.36 0 004.17 7.24l127.83 73.87a25.08 25.08 0 0025.08 0L850.42 380a8.35 8.35 0 004.17-7.23v-43l-131 78.63a25.08 25.08 0 01-25.05.01z",
  fill: "url(#hero_svg__linear-gradient-79)"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M698.54 408.41l-129.91-75a4.18 4.18 0 010-7.24l128.87-74.42a25.08 25.08 0 0125.08 0l129.92 75a4.19 4.19 0 010 7.24l-128.88 74.42a25.08 25.08 0 01-25.08 0z",
  fill: "url(#hero_svg__linear-gradient-80)"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M852.5 334l-128.88 74.41a25.08 25.08 0 01-25.08 0l-129.91-75",
  stroke: "url(#hero_svg__linear-gradient-81)",
  strokeWidth: 2.58,
  strokeMiterlimit: 10,
  fill: "none"
});

var _ref163 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 579.71,
  cy: 362.84,
  rx: 4.37,
  ry: 7.57,
  transform: "rotate(-30.35 579.633 362.82)"
});

var _ref164 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 597.08,
  cy: 372.87,
  rx: 4.37,
  ry: 7.57,
  transform: "rotate(-30.35 597 372.854)"
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-82)",
  d: "M696.07 436.18l-81.32-46.95v-12.32l81.32 46.95v12.32z"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-9",
  d: "M726.73 436.18l118.69-68.52v-5.63l-118.69 68.52v5.63zm0-9.2l118.69-68.52v-5.63l-118.69 68.52v5.63z"
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-83)",
  d: "M732.11 366.44L713.31 356l48.73-44.01 32.55 18.37-62.48 36.08z"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-23",
  d: "M750.63 293.05c3-5.42-8.51-19-10-20.49a21.57 21.57 0 00-11-6.15.82.82 0 00-.44 0 .79.79 0 00-.35.3c-1.59 2.1-.83 6.16-.42 8.57a66.67 66.67 0 001.72 7.13 115.06 115.06 0 004.53 13.3c1.11 2.64 1.79 3.39 4.62 3.12 2.13-.21 4.53 0 6.44-1.14a13 13 0 004.9-4.64z"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  d: "M750.63 293.05c3-5.42-8.51-19-10-20.49a21.57 21.57 0 00-11-6.15.82.82 0 00-.44 0 .79.79 0 00-.35.3c-1.59 2.1-.83 6.16-.42 8.57a66.67 66.67 0 001.72 7.13 115.06 115.06 0 004.53 13.3c1.11 2.64 1.79 3.39 4.62 3.12 2.13-.21 4.53 0 6.44-1.14a13 13 0 004.9-4.64z",
  fill: "url(#hero_svg__linear-gradient-84)"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  d: "M685.91 337.76a6 6 0 01-1.49-5.07c.71-5 4.8-8.56 8-12.08a84.08 84.08 0 0126.69-19.71c3.53-1.65 10-5.61 13.48-3.09 4.54 3.25 6.59 9.36 5.59 14.85s-5 11.49-10.48 12.87a113.31 113.31 0 00-11.7 4.14c-4.79 1.78-9.57 3.59-14.32 5.48-3.86 1.53-8.39 4.59-12.61 4a6.65 6.65 0 01-2.43-.77 3.68 3.68 0 01-.73-.62z",
  fill: "url(#hero_svg__linear-gradient-85)"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-109",
  d: "M728.44 339.32a59.71 59.71 0 013.56 5.83c.86 1.64.31 2.85.49 4.64a15.34 15.34 0 00.74 3.06c.85 2.72 2.93 6.7.71 9.33a1.63 1.63 0 01-1 .64c-.91.08-2.32-1.07-3.29-1.3-1.58-.38-3.15-.82-4.71-1.27a42.1 42.1 0 01-8.59-3.4 37.52 37.52 0 01-10.85-8.36c-1.1-1.32-2.5-3.48-2-5.3.42-1.56 2.07-1.84 3.5-2.29a41.18 41.18 0 019.53-1.7 65.34 65.34 0 0111.91.12z"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-110",
  d: "M733.45 362.29a2.25 2.25 0 01-1.65 1.56 4.26 4.26 0 01-2.21-.16c-5.18-1.13-9.93-3.64-14.61-6-2.71-1.4-12.43-8.07-13.58-10.25-1.56-3 1.68-5.76 4.55-5.25a27.69 27.69 0 015.58 1.79 52.49 52.49 0 016.17 3.24 78.42 78.42 0 0111.51 8.69c1.33 1.09 4.69 4.27 4.24 6.38z"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  d: "M778.23 300c.63-4.6-1.61-9.91-6.07-11.1-4.76-1.27-12.66 1.7-17.28 3.08a20.43 20.43 0 00-4.93 2 21.66 21.66 0 00-5.76 6c-3 4.06-4.9 9.12-8 12.91-4.41 5.38-9.8 10.09-14.32 15.43-.91 1.09-7.05 10.35-8.22 10.25a30.26 30.26 0 0110.92 3.13 28.24 28.24 0 014.79 3 20.94 20.94 0 012.06 1.82c.64.64 1.19 1.48 2.22 1a9.64 9.64 0 001.84-1.55l4.07-3.55c3.07-2.7 6.12-5.4 9.16-8.13 6.2-5.55 12.18-11.39 18-17.35 4.63-4.73 10.12-9.5 11.43-16.37z",
  fill: "url(#hero_svg__linear-gradient-86)"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-23",
  d: "M705.52 272.94a7.52 7.52 0 013.17-3.69c5.74-3.32 13.68-5.82 20.12-3 4.61 2 14.54 25.47 11.43 32.12-1 2.1-3 3.54-4.88 4.91-7.27 5.35-15.23 7.06-24 6.25a9.14 9.14 0 01-3.93-1c-2.77-1.67-2.51-7.41-2.75-10.22a133.79 133.79 0 01-.45-14.44c.12-3.32-.12-7.64 1.29-10.93z"
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  d: "M705.52 272.94a7.52 7.52 0 013.17-3.69c5.74-3.32 13.68-5.82 20.12-3 4.61 2 14.54 25.47 11.43 32.12-1 2.1-3 3.54-4.88 4.91-7.27 5.35-15.23 7.06-24 6.25a9.14 9.14 0 01-3.93-1c-2.77-1.67-2.51-7.41-2.75-10.22a133.79 133.79 0 01-.45-14.44c.12-3.32-.12-7.64 1.29-10.93z",
  fill: "url(#hero_svg__radial-gradient)"
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  d: "M712 290c-.14-5.7-1-14-6.82-16-1 3.12-.79 6.88-.86 9.79a133.79 133.79 0 00.45 14.44c.24 2.81 0 8.55 2.75 10.22a7.14 7.14 0 002.72.88A92.94 92.94 0 00712 290z",
  fill: "url(#hero_svg__linear-gradient-87)"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-109",
  d: "M758.2 314c2.7-.23 5.91-.79 8.06 1.27s3 5.7 3.92 8.26a60.16 60.16 0 013.82 19.98 7.07 7.07 0 01-.71 3.58 3 3 0 01-3 1.61 4.64 4.64 0 01-2.29-1.66c-3.33-3.67-6.57-8.48-10.46-11.53-1.24-1-2.81-1.23-4-2.31-1.39-1.32-2-3.69-2.59-5.46-1.21-3.73-1.18-7.67 1.24-10.92 1.08-1.5 3.58-2.58 6.01-2.82z"
});

var _ref178 = /*#__PURE__*/React.createElement("path", {
  d: "M752.08 314.38c4.18-.49 4.15 12.46 3.8 14.53-.42 2.41-1.19 4.43-3.58 5.2-2.75.9-5.62 1.75-8.42 2.58-6.37 1.89-12.88 3.23-19.38 4.58-7.09 1.46-14.19 2.93-21.39 3.8-5.06.61-12.37 1.26-16.38-2.68-3.14-3.08-4-9.39-1-12.82a14.85 14.85 0 015.63-3.73c4.73-2 9.91-2.84 14.91-3.93 5.26-1.16 10.56-2.14 15.86-3.16 9.87-1.9 19.92-3.18 29.95-4.37z",
  fill: "url(#hero_svg__linear-gradient-88)"
});

var _ref179 = /*#__PURE__*/React.createElement("path", {
  d: "M702 327.51l-.08-3.65 24.36 14a1.74 1.74 0 001.75 0l34.5-20.9.06 3a.85.85 0 01-.42.76l-34.07 20.65a1.74 1.74 0 01-1.74 0l-23.91-13.07a.88.88 0 01-.45-.79z",
  fill: "url(#hero_svg__linear-gradient-89)"
});

var _ref180 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-28",
  d: "M762.06 317.13l-34.92 21.18-24.79-13.61a.87.87 0 010-1.51L737.24 302 762 315.62a.87.87 0 01.06 1.51z"
});

var _ref181 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-31",
  d: "M709.79 324.83l29.32-17.77 17.26 9.44-29.32 17.77-17.26-9.44z"
});

var _ref182 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-61",
  d: "M725.43 328l-33.6-3.62h-.09a6.59 6.59 0 01-5.4-8.52l5-16.45 12.73-1.22s-5.94 15.44-4.91 15.55c6.75.77 18.9 2.13 21.08 2.05 2.93-.12 5.27-2 7.76-3.32a1.72 1.72 0 011.69 0c.9.55.63 1.66.06 2.34a7.34 7.34 0 01-.92.84 8 8 0 00-2 2.4 6.58 6.58 0 00-.54 2.85c-.23 2.39-.6 4.76-.86 7.1z"
});

var _ref183 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-61",
  d: "M730.14 328.55a1.45 1.45 0 01-.72.1l-8.42-1.12a1.42 1.42 0 01.37-2.82l8.41 1.11a1.43 1.43 0 01.35 2.73zm3.63-2.55a1.4 1.4 0 01-.73.09l-8.41-1.09a1.42 1.42 0 11.37-2.82l8.41 1.11a1.42 1.42 0 01.36 2.73zm2.41-2.73a1.48 1.48 0 01-.73.1l-9.33-1.24a1.42 1.42 0 11.37-2.82l9.34 1.23a1.43 1.43 0 011.22 1.6 1.41 1.41 0 01-.87 1.13zm.21-2.98a1.37 1.37 0 01-.73.1l-9.33-1.24a1.42 1.42 0 01-1.23-1.59 1.43 1.43 0 011.6-1.23l9.33 1.23a1.43 1.43 0 011.23 1.6 1.41 1.41 0 01-.87 1.13z"
});

var _ref184 = /*#__PURE__*/React.createElement("path", {
  d: "M762.93 316.61l-35.79 21.7-.73-33.8 36.23-22 .71 33.29a.89.89 0 01-.42.81z",
  fill: "url(#hero_svg__linear-gradient-90)"
});

var _ref185 = /*#__PURE__*/React.createElement("path", {
  d: "M759.86 281.53L724.5 303a.89.89 0 00-.43.77l.71 32.78a.86.86 0 00.45.75l1.91 1-.72-33.3a.89.89 0 01.42-.76l35.8-21.7-1.91-1a.87.87 0 00-.87-.01z",
  fill: "url(#hero_svg__linear-gradient-91)"
});

var _ref186 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-23",
  d: "M688.91 306.08c1.81 2.23 4.15 3.16 7 3.72 1.92.37 7.28 1.3 8.37-.82.44-.85 2.83-9.15 3.67-12.32a57.29 57.29 0 001.85-20.91c-.39-3.21-2.46-5.46-5.61-3.58a22.07 22.07 0 00-7 7 58.31 58.31 0 00-6.53 14.94c-.8 2.69-1.53 5.4-2.22 8.12-.33 1.3-.83 2 0 3.18z"
});

var _ref187 = /*#__PURE__*/React.createElement("path", {
  d: "M756.55 335.75a9.7 9.7 0 001.18-2.82m.9 4.51a9.23 9.23 0 001.14-1.94m-28.67 12.9c.56.41 1.1.83 1.63 1.28",
  stroke: "#f2f5fa",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
});

var _ref188 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-34",
  d: "M735.05 247.87a8 8 0 00.13-4.78 2.13 2.13 0 00-1.31-1.59c-.37-7-3.69-14.42-10.22-17.67-5.75-2.86-11.32-1.76-16.74 1-2.52 1.28-5.51 1.08-8.14 2.34a18.15 18.15 0 00-5.74 4.36c-3.24 3.69-5 8.58-5.72 13.3a10.36 10.36 0 00.16 5 8 8 0 001.3 2 2.9 2.9 0 01.57 2.05c.14 2.63 1.72 5.1 3.33 7.12a14.8 14.8 0 006.63 4.6 21.42 21.42 0 0011.75.38 19.15 19.15 0 004.67-1.62c2.17-1.13 3.16-2.9 4.87-4.39 3.59-3.14 8.55-4.29 11.91-7.89a11.56 11.56 0 002.55-4.21z"
});

var _ref189 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-23",
  d: "M727 265.77a16.16 16.16 0 00-2.11-5.67 5.38 5.38 0 00-1.07-.86 5.62 5.62 0 00-3.2-.77 11.35 11.35 0 00-3.53.78 28.87 28.87 0 00-5.22 2.45 9.25 9.25 0 00-2.37 1.93c-1.15 1.43-1.31 3.55-1.32 5.31 0 6.21 7.83 5.05 11.64 3.83 2.44-.79 6.54-2.93 7.18-5.68a3.86 3.86 0 000-1.32z"
});

var _ref190 = /*#__PURE__*/React.createElement("path", {
  d: "M727 265.77a16.16 16.16 0 00-2.11-5.67 5.38 5.38 0 00-1.07-.86 5.62 5.62 0 00-3.2-.77 11.35 11.35 0 00-3.53.78 28.87 28.87 0 00-5.22 2.45 9.25 9.25 0 00-2.37 1.93c-1.15 1.43-1.31 3.55-1.32 5.31 0 6.21 7.83 5.05 11.64 3.83 2.44-.79 6.54-2.93 7.18-5.68a3.86 3.86 0 000-1.32z",
  fill: "url(#hero_svg__radial-gradient-2)"
});

var _ref191 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-61",
  cx: 716.02,
  cy: 251.92,
  r: 13.05
});

var _ref192 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-34",
  d: "M719 243.37a17.2 17.2 0 00-11.67 10.09c-.74 1.82-1.19 3.84-2.51 5.3a2.58 2.58 0 01-1.85 1 2.63 2.63 0 01-1.32-.47 10.32 10.32 0 01-3-3.11 11.11 11.11 0 01-2-6 11.28 11.28 0 01.85-4 18.76 18.76 0 0118.29-12.08 14.09 14.09 0 016.73 1.89 7.81 7.81 0 002.53 1.43 7.31 7.31 0 013.39 1.16 1.51 1.51 0 01.63 1 1.68 1.68 0 01-.17.82c-.83 2-2.18 1.93-4.17 2.2a55.51 55.51 0 00-5.73.77z"
});

var _ref193 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-34",
  d: "M717.61 252.3l-.36.41c-1.1 1.19-3.42 2.46-5 1.46a4.88 4.88 0 01-1 1.67 2 2 0 01-1.85.58 2.13 2.13 0 01-1.35-1.21 5.59 5.59 0 01-.44-1.81 7.36 7.36 0 010-2.73c1-3.72 4.67-6.4 8.2-7.3a3.35 3.35 0 013 .29 3.13 3.13 0 01.9 2.24 9.25 9.25 0 01-2.1 6.4z"
});

var _ref194 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-110",
  d: "M707.12 254.86s7.11-13.65 20.28-9.33c0 0 .19-4.18-5.17-5.45-.82-.19-15.72-1.65-17.44 15"
});

var _ref195 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-61",
  d: "M707.67 253.92c-.89-1.1-3-.93-4 .07a4.1 4.1 0 00-.82 4 4.33 4.33 0 001.77 2.51 3 3 0 003 .18 2.3 2.3 0 001.11-2.67"
});

var _ref196 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-120",
  d: "M704.79 255.86s1.68-.19 2.34 3m-2.34-.74s.85-1.09 1.72-1"
});

var _ref197 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-92)",
  d: "M564.7 547.56l-50.07 22.01 172.33 99.5 50.08-22.01-172.34-99.5z"
});

var _ref198 = /*#__PURE__*/React.createElement("path", {
  d: "M674.24 541.19l-42.33-25.61-12 8.4-28.23-16.41-30.84 21.65 66.84 38.68z",
  fill: "url(#hero_svg__linear-gradient-93)"
});

var _ref199 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-123",
  d: "M609.31 512.09l17 3.49L617 378.9l-19.74 1.35z"
});

var _ref200 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-124",
  d: "M607.49 498.77c-.4-2.22-.71-4.52-1-6.74a80.28 80.28 0 01-.71-8.88c0-1.5 0-2.93.07-4.44s1.35-1 2.46-.79 2.22.4 3.33.56a34.8 34.8 0 007 .39 10.64 10.64 0 002.77-.55c.64-.24 1.75-1.27 2.46-.64.48.4 1.67 16.57 1.75 17.68 0 .56.47 2.46.15 2.86 0-.16-5.23 7-18.23.55z"
});

var _ref201 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-31",
  d: "M600.27 338.31c15.62-2.46 27.28-16.09 24-32.27A44.37 44.37 0 00609 281.31c-9.76-8-23.31-2.14-29.34 7.53-7 11.34-7.93 24.58-3.57 36.94 2.07 6 5.63 10.86 12 12.37a30.44 30.44 0 0011 .32 8.1 8.1 0 001.18-.16zm-12.68 39.88a1.07 1.07 0 110 2.14 1.07 1.07 0 010-2.14z"
});

var _ref202 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-31",
  d: "M632 370.34c-.72 2.77-1.83 5.55-4 7.37-.71-1-1.5-2.14-2.22-3.17-3.41 4.28-9.91 5-14.9 2.78s-8.72-6.58-11.58-11.18c-3.56-5.79-6.34-12.29-6.89-19-1.19-15.22 10.38-30.6 25.53-20.3 13.23 9 18.15 28.7 14.11 43.53z"
});

var _ref203 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-123",
  d: "M571.58 414a3 3 0 01-.88-.08 7.15 7.15 0 01-6.18-8l10.54-83.41a7.15 7.15 0 0114.19 1.83l-10.54 83.4a7.17 7.17 0 01-7.13 6.26zm8.95-117.17a17.58 17.58 0 007.3 13.95 11 11 0 009 1.74 16.09 16.09 0 0012.28-15.61c0-8.73-6.42-15.86-14.27-15.86s-14.35 7.06-14.35 15.78z"
});

var _ref204 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-31",
  d: "M610.42 296.21a3.07 3.07 0 01-.63 1.11 3.12 3.12 0 01-2.06.56c-15.22.39-16.81-8.49-17.29-7.46-.79 1.59-7.13 8.65-11.73 7.14-.4-.16-.32-.87-.4-1.27-.39-5.63.72-11.65 5.24-15.38a17.58 17.58 0 0113.24-3.25c4.67.63 16.17 3.65 13.63 18.55z"
});

var _ref205 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-109",
  d: "M582.36 354.88c6.34 2.46 15.06 2.62 19.66 2.85 4 .16 12.92 1.43 12.53-3.33-1-11.81 2.77-22 1-30.12-.48-2.06-1.27-3.49-5.79-6-3-1.74-24.74-5-27.67-2.85-4.2 3.17-5.31 12.92-6 17.68-.8 5.78.71 12.76 2.69 18.31.79 2.06 1.59 2.7 3.65 3.49z"
});

var _ref206 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-123",
  d: "M599.72 306.76s-2 8.16 3.73 9.75c0 0-2.07 4.91-9.28 4.6s-7.85-6.58-7.85-6.58 4.6.23 4.28-8.88l9.12 1.11zm7.53-7.93s4-3.49 5.47 1.27-4.91 10.3-7.05 5.86"
});

var _ref207 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-34",
  d: "M625.72 498.06s-6.18 6.1-18.23.63c0 0 .16 17.05 2.38 19.74 0 0 21.64 15.86 29.17 13.24s-10.7-23.23-10.7-23.23l-2.62-10.38z"
});

var _ref208 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-60",
  d: "M622.47 504.72a13.17 13.17 0 01-1.58-.16.61.61 0 11.24-1.19c3.48.64 5-1.43 5.07-1.51a.62.62 0 01.79-.15.61.61 0 01.16.79 5.57 5.57 0 01-4.68 2.22zm.88 2.93a13.12 13.12 0 01-1.59-.16.61.61 0 01-.48-.71.62.62 0 01.72-.48c3.49.64 5-1.42 5.07-1.5a.57.57 0 11.95.63c0 .16-1.42 2.22-4.67 2.22z"
});

var _ref209 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-123",
  d: "M591.32 515.1l6.18-130.65-21.33-.63-.71 130.65z"
});

var _ref210 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-124",
  d: "M574.59 496.08a1.71 1.71 0 010-.64c0-.63.08-1.19.08-1.82.08-1.9.16-3.89.24-5.79.07-2.14.15-4.28.31-6.42 0-.79.08-1.59.08-2.38v-.79c.08-.71.32-.48 1-.16a23.51 23.51 0 009.28 2 18.85 18.85 0 004.68-.63 18.6 18.6 0 002.22-.72c.71-.23.87-.07 1 .72v1.27c.16 6 .16 12.05.08 18.07-.02-.26-12.63 9.21-18.97-2.71z"
});

var _ref211 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-34",
  d: "M593.54 498.53s1.58 10.87-.56 15c0 0-21.64 22.91-32 16.33-6.34-4 12.84-23.86 12.84-23.86l.72-9.91s6.18 4.36 18.95 2.45z"
});

var _ref212 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-60",
  d: "M582 503.13a8.62 8.62 0 01-4.76-1.5.63.63 0 01-.15-.8.61.61 0 01.79-.15 6.29 6.29 0 005.87 1 .6.6 0 11.47 1.11 16.54 16.54 0 01-2.22.34zm-.47 2.78a8.62 8.62 0 01-4.76-1.51.57.57 0 11.63-.95 6.56 6.56 0 005.87 1 .6.6 0 01.48 1.11 13.75 13.75 0 01-2.26.35z"
});

var _ref213 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-125",
  d: "M607.09 303.51h-.16a.47.47 0 01-.15-.56c.79-1.59 1.66-2.46 2.69-2.62a2.6 2.6 0 011.82.56.39.39 0 01-.55.55 1.26 1.26 0 00-1.11-.31c-.71.16-1.43.87-2.06 2.22a1.14 1.14 0 01-.48.16z"
});

var _ref214 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-125",
  d: "M609.63 304.77h-.08a.43.43 0 01-.32-.47 1.65 1.65 0 00-.16-1.43 1.71 1.71 0 00-1.26-.55.4.4 0 110-.8 2.33 2.33 0 011.82.88 2.69 2.69 0 01.32 2.14c.05.08-.16.23-.32.23z"
});

var _ref215 = /*#__PURE__*/React.createElement("path", {
  d: "M567 397.53c.87-9.35 1.35-29.65 11.18-47.72 0 0 10.46 12.76 36.31 4.59 0 0 10.78 2.46 12.92 55.42a47.09 47.09 0 01-33.24 1.18l-.08-2.22A41.63 41.63 0 01567 397.53z",
  fill: "url(#hero_svg__linear-gradient-94)"
});

var _ref216 = /*#__PURE__*/React.createElement("path", {
  d: "M623.58 374c-3.88-18.48-9.11-19.59-9.11-19.59-25.85 8.17-36.31-4.59-36.31-4.59a65.6 65.6 0 00-3.73 8c3.81 2.61 31.24 28.93 49.15 16.18z",
  fill: "url(#hero_svg__linear-gradient-95)"
});

var _ref217 = /*#__PURE__*/React.createElement("path", {
  d: "M584.82 407.44a40.35 40.35 0 009.35 1.43v-26.08c0-.08-5.07 21.48-9.35 24.65z",
  fill: "url(#hero_svg__linear-gradient-96)"
});

var _ref218 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-123",
  d: "M605.82 373.27a8 8 0 01-3-.63c-6-2.78-34.72-13.8-36.39-18.79-.47-1.27 1.35-6.9 1.11-7.77-.39-1.43-2.46-1.59-3.72-2.46a17 17 0 01-2.38-1.58 2.26 2.26 0 01-.72-2.62 2.32 2.32 0 012-.95 5.26 5.26 0 012.14.71c11.73 5.39 23.31 11 35 16.41l3.57-30a7.14 7.14 0 1114.19 1.66L613 366.93a7 7 0 01-3.57 5.39 7.58 7.58 0 01-3.57.95z"
});

var _ref219 = /*#__PURE__*/React.createElement("path", {
  d: "M400.86 125.38a10 10 0 0110.19-.1l161.52 93.26a20 20 0 0110 17.36v324.75a9.9 9.9 0 01-4.72 8.48c-1.25.8-26.22 15.75-26.22 15.75l-29.52-43.22 3.11-9.79-106.5-61.48a20 20 0 01-10-17.37V175.16l-35.69-33z",
  fill: "url(#hero_svg__linear-gradient-97)"
});

var _ref220 = /*#__PURE__*/React.createElement("path", {
  d: "M555.73 576.75v-324.7a20 20 0 00-10-17.36l-161.56-93.26a10 10 0 00-15.05 8.68v324.75a20 20 0 0010 17.36l161.52 93.26a10 10 0 0015.06-8.73z",
  fill: "url(#hero_svg__linear-gradient-98)"
});

var _ref221 = /*#__PURE__*/React.createElement("path", {
  d: "M543.69 252.05a8.14 8.14 0 00-4-7l-151-87.14a5 5 0 00-7.53 4.37v312.58a8.14 8.14 0 004 7l151 87.19a5 5 0 007.53-4.37z",
  fill: "url(#hero_svg__linear-gradient-99)"
});

var _ref222 = /*#__PURE__*/React.createElement("path", {
  d: "M531.14 492.67l-136.88-79.05a2 2 0 00-3 1.76v55.41a5 5 0 002.51 4.37l136.93 79.05a2 2 0 003-1.76V497a5.22 5.22 0 00-2.56-4.37z",
  fill: "url(#hero_svg__linear-gradient-100)"
});

var _ref223 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-9",
  cx: 515.63,
  cy: 503.95,
  rx: 3.51,
  ry: 6.12,
  transform: "rotate(-30.34 515.732 504.015)"
});

var _ref224 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-9",
  d: "M498.36 496a2 2 0 001.76-1 2 2 0 00-.75-2.76l-91.66-52.9a2 2 0 00-2.76.75 2 2 0 00.76 2.76l91.65 52.91a2.46 2.46 0 001 .24z"
});

var _ref225 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-9",
  cx: 515.63,
  cy: 524.03,
  rx: 3.51,
  ry: 6.12,
  transform: "rotate(-30.34 515.733 524.089)"
});

var _ref226 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-9",
  d: "M498.36 516.06a2 2 0 001.76-1 2 2 0 00-.75-2.76l-91.66-52.9a2 2 0 10-2 3.51l91.65 52.9a2.46 2.46 0 001 .25z"
});

var _ref227 = /*#__PURE__*/React.createElement("path", {
  d: "M432.06 393.75v24.69a2 2 0 01-3 1.76l-34.79-20.08a6 6 0 01-3-5.22v-24.7a2 2 0 013-1.75l34.79 20.08a6.08 6.08 0 013 5.22z",
  fill: "url(#hero_svg__linear-gradient-101)"
});

var _ref228 = /*#__PURE__*/React.createElement("path", {
  d: "M432.06 314.12v24.69a2 2 0 01-3 1.76l-34.79-20.08a6 6 0 01-3-5.22v-24.69a2 2 0 013-1.76l34.79 20.08a6.08 6.08 0 013 5.22z",
  fill: "url(#hero_svg__linear-gradient-102)"
});

var _ref229 = /*#__PURE__*/React.createElement("path", {
  d: "M432.74 380.31v-28.9a4.18 4.18 0 00-2.07-3.61l-36.93-21.33a1.67 1.67 0 00-2.49 1.45v28.9a4.18 4.18 0 002.07 3.61l36.93 21.33a1.67 1.67 0 002.49-1.45z",
  fill: "url(#hero_svg__linear-gradient-103)"
});

var _ref230 = /*#__PURE__*/React.createElement("path", {
  d: "M428.57 371.36c-2.6.81-5.52-1.34-7.44-3.47a46.86 46.86 0 01-4.21-5.39 26.92 26.92 0 00-3.61-4.9c-1.52-1.44-3.68-2.48-5.64-2.11s-3.49 2.25-5.65 2.23c-2.58 0-4.46-2.7-5-5.06s-.46-4.86-1.82-7l.26 11.73 33.29 19.22-.15-5.24z",
  fill: "url(#hero_svg__linear-gradient-104)"
});

var _ref231 = /*#__PURE__*/React.createElement("path", {
  d: "M556.74 576.75h-2v-324.7a19.19 19.19 0 00-9.54-16.51l-161.53-93.26 1-1.76 161.53 93.26a21.11 21.11 0 0110.54 18.27z",
  fill: "url(#hero_svg__linear-gradient-105)"
});

var _ref232 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-28",
  d: "M518.14 464.62a5.34 5.34 0 01-2.76-.76l-67.51-39a15.53 15.53 0 01-7.78-13.45v-77.29a5.47 5.47 0 012.76-4.77 5.41 5.41 0 015.52 0l67.51 39a15.53 15.53 0 017.78 13.45v77.3a5.49 5.49 0 01-2.76 4.76 5.39 5.39 0 01-2.76.76zM448.37 424l67.51 39a4.56 4.56 0 004.52 0 4.45 4.45 0 002.25-3.91V381.8a14.62 14.62 0 00-7.27-12.6l-67.51-39a4.56 4.56 0 00-4.52 0 4.46 4.46 0 00-2.26 3.92v77.29a14.61 14.61 0 007.28 12.59z"
});

var _ref233 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-139",
  d: "M506.14 286l8.68 5v-21l-8.68-5z"
});

var _ref234 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M506.14 286l8.68 5v41.81l-8.68-5z"
});

var _ref235 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-139",
  d: "M494 304.65l8.69 5V263.3l-8.69-5z"
});

var _ref236 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M494 304.65l8.69 5v16.57l-8.69-5z"
});

var _ref237 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-139",
  d: "M481.87 283.07l8.63 5v-31.4l-8.63-5z"
});

var _ref238 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M481.87 283.07l8.63 5v31.42l-8.63-5z"
});

var _ref239 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-139",
  d: "M469.72 254.26l8.63 5V250l-8.63-5z"
});

var _ref240 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M469.72 254.26l8.63 5v53.55l-8.63-5z"
});

var _ref241 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-139",
  d: "M457.57 254.21l8.63 5v-15.89l-8.63-5z"
});

var _ref242 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M457.57 254.21l8.63 5v46.93l-8.63-5z"
});

var _ref243 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-139",
  d: "M445.4 250.51l8.68 5v-21l-8.68-5z"
});

var _ref244 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M445.4 250.51l8.68 5v41.81l-8.68-5z"
});

var _ref245 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-139",
  d: "M433.25 269.13l8.68 5v-46.36l-8.68-5z"
});

var _ref246 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M433.25 269.13l8.68 5v16.56l-8.68-5z"
});

var _ref247 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-139",
  d: "M421.12 247.54l8.64 5v-31.4l-8.64-5z"
});

var _ref248 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M421.12 247.54l8.64 5V284l-8.64-5z"
});

var _ref249 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-139",
  d: "M409 218.73l8.64 5v-9.28l-8.64-5z"
});

var _ref250 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M409 218.73l8.64 5v53.56l-8.64-5z"
});

var _ref251 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-139",
  d: "M396.82 218.68l8.64 5v-15.89l-8.64-5z"
});

var _ref252 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M396.82 218.68l8.64 5v46.93l-8.64-5z"
});

var _ref253 = /*#__PURE__*/React.createElement("path", {
  d: "M510.21 407.7c0-14.91-10.54-33.08-23.54-40.61-6.88-4-13.1-4.16-17.42-1.25l-10.14 5.82L492 429.28l11.19-6.47c4.37-2.36 7-7.58 7-15.11z",
  fill: "url(#hero_svg__linear-gradient-106)"
});

var _ref254 = /*#__PURE__*/React.createElement("path", {
  d: "M499.27 414.07c0 14.91-10.55 20.93-23.55 13.4s-23.54-25.69-23.54-40.6 10.55-20.93 23.54-13.4 23.55 25.7 23.55 40.6z",
  fill: "url(#hero_svg__linear-gradient-107)"
});

var _ref255 = /*#__PURE__*/React.createElement("path", {
  d: "M498.31 423.91l-1.81-.85a21.4 21.4 0 001.76-9c0-14.55-10.34-32.37-23-39.7l1-1.76c13.25 7.63 24 26.25 24 41.46a22.77 22.77 0 01-1.95 9.85z",
  fill: "url(#hero_svg__linear-gradient-108)"
});

var _ref256 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 279.46,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 565.568 279.468)"
});

var _ref257 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 274.45,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.26 274.452)"
});

var _ref258 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 289.5,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 565.572 289.504)"
});

var _ref259 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 284.49,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.26 284.498)"
});

var _ref260 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 299.54,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 565.576 299.54)"
});

var _ref261 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 294.53,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.3 578.007 294.457)"
});

var _ref262 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 309.58,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 565.575 309.586)"
});

var _ref263 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 304.57,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.258 304.565)"
});

var _ref264 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 319.62,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 565.57 319.617)"
});

var _ref265 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 314.61,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.257 314.61)"
});

var _ref266 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 329.66,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 565.574 329.654)"
});

var _ref267 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 324.64,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.261 324.647)"
});

var _ref268 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 339.69,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.3 569.4 339.868)"
});

var _ref269 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 334.68,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.265 334.683)"
});

var _ref270 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 349.73,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 565.567 349.73)"
});

var _ref271 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 344.72,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.26 344.715)"
});

var _ref272 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 359.77,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 565.571 359.767)"
});

var _ref273 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 354.76,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.259 354.76)"
});

var _ref274 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 369.81,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 565.575 369.803)"
});

var _ref275 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 364.8,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.262 364.796)"
});

var _ref276 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 379.85,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.3 569.499 380.226)"
});

var _ref277 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.31,
  cy: 374.84,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.253 374.837)"
});

var _ref278 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 389.89,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 565.569 389.88)"
});

var _ref279 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 384.88,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.256 384.873)"
});

var _ref280 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 399.93,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 565.568 399.925)"
});

var _ref281 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 394.92,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.26 394.91)"
});

var _ref282 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 409.97,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 565.572 409.961)"
});

var _ref283 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 404.95,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.25 404.95)"
});

var _ref284 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 565.63,
  cy: 420,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 565.567 419.993)"
});

var _ref285 = /*#__PURE__*/React.createElement("ellipse", {
  className: "hero_svg__cls-22",
  cx: 574.32,
  cy: 414.99,
  rx: 2.46,
  ry: 1.41,
  transform: "rotate(-59.66 574.254 414.986)"
});

var _ref286 = /*#__PURE__*/React.createElement("path", {
  d: "M368.48 227.72l-.89.55s4.29 9.15 1.87 13-8.46 5.13-8.46 5.13l1.23-3.7-4.45.46 1.46-3.1-4.34-.7 6.16-3s-12-12.89-4.37-19.23a20.52 20.52 0 0111.74-4.53c1.78-.07.05 15.12.05 15.12z",
  fill: "url(#hero_svg__linear-gradient-109)"
});

var _ref287 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-110)",
  d: "M368.3 190.12v30.67l-15.47-12.43-1.14-12.99 16.61-5.25z"
});

var _ref288 = /*#__PURE__*/React.createElement("path", {
  d: "M352.19 195.49c14.72-4.13 13.17 16.1 13.17 16.1s5.39-9 9.86-10 8.78 6.27 8.78 6.27l-4.16-.35 2.69 5.05-4.43-1.19-.38 5.83-4.48-4.79c.51.55-.89 4.51-1.19 5.17a22.2 22.2 0 01-4.35 6.32c-3.08 3.11-5.15 1.6-7.64-1.25a54.58 54.58 0 01-5.38-7.42c-2.67-4.37-6.3-10.49-5.59-15.86a4.29 4.29 0 013.1-3.88z",
  fill: "url(#hero_svg__linear-gradient-111)"
});

var _ref289 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-146",
  d: "M324.39 176.59a.87.87 0 01.48 0 26.05 26.05 0 0012.94.26 10.84 10.84 0 013.33-.36 5.49 5.49 0 012.29.89c1.53-4.11 5.12-7.17 10.7-9.08l1.14-.39c5.58-1.91 10.29-1.7 14 .62a5.59 5.59 0 011.26-2.12 10.55 10.55 0 012.84-1.77 25.85 25.85 0 0010.07-8.14.84.84 0 01.41-.29.83.83 0 01.6 0 .87.87 0 01.55.89c0 .35-.09 1.9-.1 2.33-.08 1.88-1.25 6.18-.3 10.5.08.41.17.9.23 1.41l-2.27 1.17 2.39.79a10.67 10.67 0 01-1.32 5.33l-3.28-.46 1.91 2.17a9.82 9.82 0 01-4.63 2.19 8.76 8.76 0 011.25 2.78 5.45 5.45 0 01-.79 4.24c-1.13 1.8-3.3 3.55-6.63 5.34a2.41 2.41 0 00-1 1.75c0 1-1.53 2.06-4.81 3.23h-.13a15 15 0 01-4.36.93 1.74 1.74 0 01-1.42-.53 2.42 2.42 0 00-1.88-.77c-3.92.66-6.81.58-8.82-.25a5.3 5.3 0 01-3.07-3.12.31.31 0 010-.08 18.26 18.26 0 01-.56-2.54 10.53 10.53 0 01-1.88.75l-.52-2.58-.94 2.77-.68-1.39-.67 1.52a8.19 8.19 0 01-4.46-1.73l2-3.33-3.34 2.08a11.86 11.86 0 01-2.19-2.94l1.34-1.36-1.91.35 2-1.94-2.49.88c-2-3.35-5-5.61-6.06-6.88-.27-.32-1.26-1.48-1.51-1.74a1 1 0 01-.21-.34.87.87 0 01.5-1.04z"
});

var _ref290 = /*#__PURE__*/React.createElement("path", {
  d: "M324.39 176.59a.87.87 0 01.48 0 26.05 26.05 0 0012.94.26 10.84 10.84 0 013.33-.36 5.49 5.49 0 012.29.89c1.53-4.11 5.12-7.17 10.7-9.08l1.14-.39c5.58-1.91 10.29-1.7 14 .62a5.59 5.59 0 011.26-2.12 10.55 10.55 0 012.84-1.77 25.85 25.85 0 0010.07-8.14.84.84 0 01.41-.29.83.83 0 01.6 0 .87.87 0 01.55.89c0 .35-.09 1.9-.1 2.33-.08 1.88-1.25 6.18-.3 10.5.08.41.17.9.23 1.41l-2.27 1.17 2.39.79a10.67 10.67 0 01-1.32 5.33l-3.28-.46 1.91 2.17a9.82 9.82 0 01-4.63 2.19 8.76 8.76 0 011.25 2.78 5.45 5.45 0 01-.79 4.24c-1.13 1.8-3.3 3.55-6.63 5.34a2.41 2.41 0 00-1 1.75c0 1-1.53 2.06-4.81 3.23h-.13a15 15 0 01-4.36.93 1.74 1.74 0 01-1.42-.53 2.42 2.42 0 00-1.88-.77c-3.92.66-6.81.58-8.82-.25a5.3 5.3 0 01-3.07-3.12.31.31 0 010-.08 18.26 18.26 0 01-.56-2.54 10.53 10.53 0 01-1.88.75l-.52-2.58-.94 2.77-.68-1.39-.67 1.52a8.19 8.19 0 01-4.46-1.73l2-3.33-3.34 2.08a11.86 11.86 0 01-2.19-2.94l1.34-1.36-1.91.35 2-1.94-2.49.88c-2-3.35-5-5.61-6.06-6.88-.27-.32-1.26-1.48-1.51-1.74a1 1 0 01-.21-.34.87.87 0 01.5-1.04z",
  fill: "url(#hero_svg__linear-gradient-112)"
});

var _ref291 = /*#__PURE__*/React.createElement("path", {
  d: "M335.28 181.18c3.7.23 6.72.7 8.1 2.77s1.65 5.54 1.93 8.54c0 .34.06.68.11 1a13.67 13.67 0 01-1.87.81l-.52-2.58-.94 2.77-.68-1.39-.67 1.52a8.19 8.19 0 01-4.46-1.73l2-3.33-3.34 2.08a11.86 11.86 0 01-2.19-2.94l1.34-1.36-1.91.35 2-1.94-2.49.88c-2-3.35-5-5.61-6.06-6.88-.27-.32-1.26-1.48-1.51-1.74 3.7 2.75 7.44 2.93 11.16 3.17z",
  fill: "url(#hero_svg__linear-gradient-113)"
});

var _ref292 = /*#__PURE__*/React.createElement("path", {
  d: "M354.18 171.25c-.55-.15-2.5.8-2.5.8-.46.23-.65.7-.32.85a2.94 2.94 0 002.28-.33c.93-.54 1.1-1.17.54-1.32z",
  fill: "url(#hero_svg__linear-gradient-114)"
});

var _ref293 = /*#__PURE__*/React.createElement("path", {
  d: "M355 173.12c-1.13.45-.11 1.39.63 1.29s1.67-.82 1.38-1.2-1.43-.33-2-.09z",
  fill: "url(#hero_svg__linear-gradient-115)"
});

var _ref294 = /*#__PURE__*/React.createElement("path", {
  d: "M357.85 169.76a2.37 2.37 0 00-1.53 1.85c.07.5.73.5 2.23.21s2.58-1.42 2.44-1.82-2.28-.44-3.14-.24z",
  fill: "url(#hero_svg__linear-gradient-116)"
});

var _ref295 = /*#__PURE__*/React.createElement("path", {
  d: "M373.43 173.68c.11-1.38.08-3.3 3.36-6a23.42 23.42 0 003.84-3.39 25.12 25.12 0 004.4-7.17c0 .35-.09 1.9-.1 2.33-.08 1.88-1.25 6.18-.3 10.5.08.41.17.9.23 1.41l-2.27 1.17 2.39.79a10.67 10.67 0 01-1.32 5.33l-3.28-.46 1.91 2.17a8.87 8.87 0 01-4.64 2.19c-.18-.29-.37-.57-.55-.82-1.6-2.36-3.86-5.56-3.67-8.05z",
  fill: "url(#hero_svg__linear-gradient-117)"
});

var _ref296 = /*#__PURE__*/React.createElement("path", {
  d: "M350.89 191c.56 1.25 1.7 1.68 4.1.83.29-.1.6-.22.92-.35 2.53-1.08 3.53-1.84 6.34-2.83s4.07-1 6.71-1.75c.35-.09.65-.19.94-.29 2.4-.85 3-1.87 2.69-3.21 2.53.92.81 4.12-.79 5.77s-3.91 3-7.41 4.37l-.77.27c-3.58 1.13-6.24 1.51-8.52 1.22-2.24-.28-5.61-1.71-4.21-4z",
  fill: "url(#hero_svg__linear-gradient-118)"
});

var _ref297 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-154",
  d: "M372.68 187.21c.41-.71 1-1.91.55-2.73a.06.06 0 00-.11 0 3.07 3.07 0 01-1.56 1.9.06.06 0 000 .1l1 .73a.07.07 0 00.09 0zm-1.11 1.48a10.06 10.06 0 00.76-.94.11.11 0 000-.13l-1.11-.79a.06.06 0 00-.1.06l.32 1.76c0 .1.09.12.16 0zm-.57.25l-.34-1.86a.19.19 0 00-.25-.14l-.32.12c-.28.1-.61.21-1 .3h-.08a.18.18 0 00-.05.33l1.91 1.29a.07.07 0 00.1-.06zm-2.63 2.2a15.5 15.5 0 002.11-1.43.24.24 0 000-.39l-2.25-1.53a.06.06 0 00-.09.05l-.11 3.08a.24.24 0 00.36.22zm-.85.22l.1-3.3a.25.25 0 00-.3-.25l-1 .22c-.57.12-1.12.24-1.73.4a.18.18 0 00-.07.31l2.87 2.66a.06.06 0 00.1 0zm-2.89 1.55c.78-.31 1.49-.62 2.16-.94a.25.25 0 00.06-.4l-2.48-2.31a.06.06 0 00-.1 0v3.38a.25.25 0 00.34.23zm-.94.03a.06.06 0 00.11 0v-3.91a.25.25 0 00-.32-.23l-1 .35c-.37.13-.71.25-1 .38a.25.25 0 00-.1.38l2.41 3.07zm-2.89 1.13c.72-.17 1.47-.37 2.27-.62a.24.24 0 00.12-.38l-2.09-2.66a.06.06 0 00-.11 0l-.48 3.36a.24.24 0 00.29.27zm-.8-.07l.59-3.87a.19.19 0 00-.26-.2c-.57.26-1.08.51-1.6.77l-1 .47a.18.18 0 00-.06.28l2.19 2.58a.06.06 0 00.1 0zm-3.49.61a15.53 15.53 0 002.54-.2.25.25 0 00.15-.4l-2-2.34a.07.07 0 00-.11 0c-.13.41-.6 1.93-.81 2.59a.25.25 0 00.24.32zm-1.76-1.96l.9 1.66a.06.06 0 00.11 0l.69-2.2a.18.18 0 00-.25-.22h-.07c-.34.15-.67.27-.95.37l-.32.11a.18.18 0 00-.11.26zm-.91 1.58a8.36 8.36 0 001.18.27c.1 0 .14-.05.1-.14l-.85-1.57a.06.06 0 00-.11 0l-.38 1.32a.09.09 0 00.06.11zm-1.09-.39l.46.19a.06.06 0 00.08 0l.35-1.22a.05.05 0 00-.06-.07 3.8 3.8 0 01-1.44 0 2.39 2.39 0 01-1-.48.06.06 0 00-.1.06 1.18 1.18 0 00.1.3 3.15 3.15 0 001.58 1.29z"
});

var _ref298 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-155",
  d: "M370.69 175.13c-1.92.6-3.55 3.57-6.65 6.26-1.14 1-2.41 1.89-2.6 2a17.17 17.17 0 002.23-.5 4.47 4.47 0 004.58.76 4 4 0 002.91-4.62 4.77 4.77 0 00-.41-1.38 11.48 11.48 0 00-3.34 1.6 10.71 10.71 0 013.33-2.65 6 6 0 012-.39s-.91-1.49-2.06-1.11zm-23.33 9.72a10.89 10.89 0 014.25 0 11.85 11.85 0 00-3.61.84 5 5 0 00.55 1.34 4 4 0 005.16 1.77 4.48 4.48 0 003.1-3.45 16.33 16.33 0 002.05-1c-.23 0-1.79.09-3.29 0-4.12-.15-7.23-1.46-9.11-.73-1.13.43-.89 2.15-.89 2.15a6 6 0 011.79-1z"
});

var _ref299 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-156",
  d: "M351.62 184.86a11.57 11.57 0 00-3.6.83 5.4 5.4 0 00.55 1.34 4 4 0 005.15 1.79 4.46 4.46 0 003.09-3.45 26.63 26.63 0 01-5.19-.51zm12.05-1.92a4.47 4.47 0 004.57.75 4 4 0 002.9-4.61 4.77 4.77 0 00-.41-1.38 11.29 11.29 0 00-3.32 1.6 28.09 28.09 0 01-3.74 3.64z"
});

var _ref300 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-157",
  d: "M365.36 182.93c-.38-.67 3.19-3 3.19-3 1.08-.89 1.27-.06 1.19.42s-.31 2.15-1.44 2.74-2.68.3-2.94-.16zm-15.04 4.25a3.94 3.94 0 002.84 1.24c1.27-.16 2.3-1.19 2.19-1.95s-4.36-.36-4.36-.36c-.6.03-1.55.22-.67 1.07z"
});

var _ref301 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-154",
  d: "M366.51 181.5s-1.16.76-1 1.34 1.63-1.31 2-1.67-.11-.41-1.05.33zm-12.92 4.56s1.38-.13 1.61.43-2.09 0-2.64 0-.17-.39 1-.4z"
});

var _ref302 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-119)",
  d: "M418.79 547.88l-56.6 31.21 78.79 46.7 55.56-34.32-77.75-43.59z"
});

var _ref303 = /*#__PURE__*/React.createElement("path", {
  d: "M374.08 548.59l-53.85-15.73v21.2a2.5 2.5 0 001.26 2.19l52.59 30.37a8.34 8.34 0 008.42 0l52.17-30.12a2.52 2.52 0 001.26-2.19V533l-53.43 15.67a8.54 8.54 0 01-8.42-.08z",
  fill: "url(#hero_svg__linear-gradient-120)"
});

var _ref304 = /*#__PURE__*/React.createElement("path", {
  d: "M321.49 535l52.59 30.38a8.39 8.39 0 008.42 0l52.17-30.12a2.53 2.53 0 000-4.38l-52.59-30.46a8.39 8.39 0 00-8.42 0l-52.17 30.12a2.6 2.6 0 000 4.46z",
  fill: "url(#hero_svg__linear-gradient-121)"
});

var _ref305 = /*#__PURE__*/React.createElement("path", {
  d: "M378.29 568.2a9.61 9.61 0 01-5.05-1.35l-52.59-30.38 1.68-2.94 52.59 30.38a6.89 6.89 0 006.73 0l52.17-30.13 1.69 3-52.17 30.12a9.64 9.64 0 01-5 1.35z",
  fill: "url(#hero_svg__linear-gradient-122)"
});

var _ref306 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-123)",
  d: "M467.23 578.79l-55.67 30.12 136.72 77.3 58.85-35.39-139.9-72.03z"
});

var _ref307 = /*#__PURE__*/React.createElement("path", {
  d: "M449.53 592.81l-53.85-15.74v21.21a2.51 2.51 0 001.26 2.19l52.59 30.37a8.33 8.33 0 008.41 0l52.17-30.12a2.51 2.51 0 001.27-2.19v-21.29l-53.44 15.65a8.57 8.57 0 01-8.41-.08z",
  fill: "url(#hero_svg__linear-gradient-124)"
});

var _ref308 = /*#__PURE__*/React.createElement("path", {
  d: "M396.94 579.26l52.59 30.38a8.37 8.37 0 008.41 0l52.17-30.13a2.52 2.52 0 000-4.37l-52.59-30.46a8.33 8.33 0 00-8.41 0l-52.17 30.12a2.6 2.6 0 000 4.46z",
  fill: "url(#hero_svg__linear-gradient-125)"
});

var _ref309 = /*#__PURE__*/React.createElement("path", {
  d: "M453.74 612.41a9.7 9.7 0 01-5.05-1.34l-52.59-30.38 1.68-2.94 52.59 30.37a6.84 6.84 0 006.73 0L509.27 578l1.68 2.94-52.17 30.13a9.69 9.69 0 01-5 1.34z",
  fill: "url(#hero_svg__linear-gradient-126)"
});

var _ref310 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-127)",
  d: "M348.02 580.91l-36.53 23.13 50.27 29.66 38.75-22.25-52.49-30.54z"
});

var _ref311 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-24",
  d: "M312.4 588s-8.13 10.75-1.25 15.74c3.49 2.54 9.74 2.11 15.11-.12a22.61 22.61 0 004.94-2.78c17.64-13.23 17.55-17.44 17.55-17.44 1.05-4-5.14-4.23-7.77-3.89-6.05.77-11.82 4.07-16.91 7.22M386.71 529c2.51-1.55 13.41-6.66 16.53-4.19 5 3.95-10.08 17.43-12.92 19.28-4.32 2.82-9 5.79-14.37 5.83a9 9 0 01-6.82-2.76c-4-4.52 1-11.42 4.13-15"
});

var _ref312 = /*#__PURE__*/React.createElement("path", {
  d: "M328.94 433.88s-8.18.76-16.67 36.79 12.29 32.91 12.29 32.91l9.58-40.92z",
  fill: "url(#hero_svg__linear-gradient-128)"
});

var _ref313 = /*#__PURE__*/React.createElement("path", {
  d: "M328.94 433.88s-8.18.76-16.67 36.79 12.29 32.91 12.29 32.91l9.58-40.92z",
  fill: "url(#hero_svg__linear-gradient-129)"
});

var _ref314 = /*#__PURE__*/React.createElement("path", {
  d: "M343.15 485.52l-.47 7.83c-1.13 18.48-3.6 90.45-6.09 94.24-4.39 6.65-12.91 9.22-19.62 10.08a13.51 13.51 0 01-13.15-7.9s13.29-99.65 14.81-110.53z",
  fill: "url(#hero_svg__linear-gradient-130)"
});

var _ref315 = /*#__PURE__*/React.createElement("path", {
  d: "M341.08 526.67c.66-14.15 1.21-26.93 1.6-33.32.16-2.61.31-5.22.47-7.83l-24.52-6.28c-.48 3.5-2.2 16.23-4.29 31.86 5.84 8.33 16.45 12.98 26.74 15.57z",
  fill: "url(#hero_svg__linear-gradient-131)"
});

var _ref316 = /*#__PURE__*/React.createElement("path", {
  d: "M381.16 494.1c5.5-4.57 9.43-10.37 5.31-17.34-3-5-11.56-3.93-16.3-3.31a122.07 122.07 0 00-21.95 5.36c-3.47 1.13-6.6 2.76-10.26 2.76h-20.28c-1.35 6-3.52 11.35-.31 17.21 5.5 10 18 17.12 29.4 14.25 6.6-1.66 12.59-5.1 18.36-8.61 5.44-3.33 11.15-6.27 16.03-10.32z",
  fill: "url(#hero_svg__linear-gradient-132)"
});

var _ref317 = /*#__PURE__*/React.createElement("path", {
  d: "M331 494c6.65 2.55 14.28 3.27 20.86.08 8.1-3.93 9.61-12.12 12.41-19.6a146.16 146.16 0 00-16 4.36c-3.47 1.13-6.6 2.76-10.26 2.76h-20.28c-.15.7-.32 1.39-.49 2.07 2.09 5.08 8.89 8.43 13.76 10.33z",
  fill: "url(#hero_svg__linear-gradient-133)"
});

var _ref318 = /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-61",
  cx: 342.06,
  cy: 415.33,
  r: 14.86
});

var _ref319 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-61",
  d: "M334.87 423.61l-2.01 10.27 11.31 3 2.71-11.24"
});

var _ref320 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-34",
  d: "M347.52 416.65a5.3 5.3 0 00.59-3c-.5-3.08-3.6-3.34-6-4.05a17.1 17.1 0 00-9.59-.22c-4.33 1.2-7.79 3.88-9.35 8.18a6.7 6.7 0 00.16 5.41c.07.12.14.24.22.35a4 4 0 004.49 1.7 7.52 7.52 0 006 5.21 5.81 5.81 0 006.29-4.35c-.13.66 1.32 1.47 1.79 1.61a3.12 3.12 0 002.64-.47 3.73 3.73 0 001.57-3c.05-1.28-.9-2.39-.76-3.67a8.51 8.51 0 011.26-2.45c.59-1.08.93-2.46 2.2-2.92a7.08 7.08 0 012.35-.27 11.73 11.73 0 006.4-1.62 5.5 5.5 0 002.51-5.74A5.41 5.41 0 00357 404a11.92 11.92 0 00-4.86-.63 30.48 30.48 0 00-18 6.85"
});

var _ref321 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-173",
  d: "M355.39 443.12c3.26 9.72 5.44 41.64 5.44 41.64s-27.48 17.35-44.38-5.34c0 0-2.15-35.9 12.49-46.89 3.62-2.72 23.14.75 26.45 10.59z"
});

var _ref322 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-173",
  d: "M355.39 443.12c3.26 9.72 5.44 41.64 5.44 41.64s-27.48 17.35-44.38-5.34c0 0-2.15-35.9 12.49-46.89 3.62-2.72 23.14.75 26.45 10.59z"
});

var _ref323 = /*#__PURE__*/React.createElement("path", {
  d: "M350.16 439.37c-8.08 3.34-8.57 14.92-8.65 22.31-.1 9.82 1.41 19.38 2.94 29a47.74 47.74 0 0016.38-5.92s-2.18-31.92-5.44-41.64a11.7 11.7 0 00-3.63-5 3.5 3.5 0 01-1.6 1.25z",
  fill: "url(#hero_svg__linear-gradient-136)"
});

var _ref324 = /*#__PURE__*/React.createElement("path", {
  d: "M388.39 482.45l4.94 46.92c-1.59 4.68-11.41 12.25-19.6 13.67a11.91 11.91 0 01-7.82-.87c-5-2.8-4.68-34.5-5-45.42",
  fill: "url(#hero_svg__linear-gradient-137)"
});

var _ref325 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-61",
  d: "M379.53 514.11l-4.16-7.62h.3a7.82 7.82 0 011.33.51 1.6 1.6 0 001.37-.06 1.26 1.26 0 00.5-1.21 2.52 2.52 0 00-.59-1.23 10.5 10.5 0 00-3.62-2.45c-.25-.13-.5-.25-.74-.39-.6-.32-1.17-.68-1.76-1l-.26-.48a1.61 1.61 0 00-2.19-.64l-.11.07c-.12 0-.24-.06-.37-.07a6.32 6.32 0 00-6.2 2.92 5.84 5.84 0 00-.35.57 1.62 1.62 0 00-1.34.09 1.6 1.6 0 00-.64 2.18l7.62 14a1.62 1.62 0 001.42.83 1.65 1.65 0 00.77-.19 1.61 1.61 0 00.82-1.25l.8 1.46a1.61 1.61 0 001.41.84 1.64 1.64 0 00.77-.2 1.6 1.6 0 00.83-1.46l.64 1.16a1.61 1.61 0 001.41.84 1.64 1.64 0 00.77-.2 1.6 1.6 0 00.64-2.18l-1.5-2.77a1.55 1.55 0 001 .37 1.65 1.65 0 00.77-.19 1.62 1.62 0 00.66-2.25z"
});

var _ref326 = /*#__PURE__*/React.createElement("path", {
  d: "M376.65 501.33c-4.4 4-11.38 8.38-17.33 7.81 0 0-9.24-16.84-12.36-30.75s-9.67-42.25 1.59-43.13c6.06-.47 10.44 15.76 11.1 19.73 2.77 16.51 9.09 31.65 17 46.34z",
  fill: "url(#hero_svg__linear-gradient-138)"
});

var _ref327 = /*#__PURE__*/React.createElement("path", {
  d: "M341.52 403.4s22.29-11.93 22.71-2.93c.22 4.95-13.09 14.59-13.09 14.59z",
  fill: "url(#hero_svg__linear-gradient-139)"
});

var _ref328 = /*#__PURE__*/React.createElement("path", {
  d: "M325 413.62s5.61 14.29 26.11 1.44l4.46-7.75S355.07 397 341.2 397c-16.2 0-16.2 16.62-16.2 16.62z",
  fill: "url(#hero_svg__linear-gradient-140)"
});

var _ref329 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-61",
  d: "M346.59 414.78a3.47 3.47 0 00-3.3 1.24 4.32 4.32 0 00-.83 3.51 4.48 4.48 0 002.78 3.35 3.82 3.82 0 004.14-1.06c1.83-2.21-.09-6.48-2.79-7.04z"
});

var _ref330 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-120",
  d: "M344.83 417.23a2.76 2.76 0 013.51 2.2m-.95-1.43a1.93 1.93 0 00-2.37 1.82"
});

var _ref331 = /*#__PURE__*/React.createElement("path", {
  d: "M760 445.77c9.82-3.51-2.19-19.29-2.37-26.83-.08-6.32 5.79-20.52 6.32-25.87s-7.63-11.93-9.56-6.41c-.79 2.28 2.72.71 2.72.71s-6-3.78-6.67 3.07c.7 1 2.46-.44 2.46-.44s-5.53-2.11-5.79 3.86a3.91 3.91 0 015.44 2.89c.61 3.42-7 17.71-7.28 24.82-.5 8.59 2.31 28.67 14.73 24.2z",
  fill: "url(#hero_svg__linear-gradient-141)"
});

var _ref332 = /*#__PURE__*/React.createElement("path", {
  d: "M753.63 461.65l-7.19 15.78-11-1.67s-.27 12.72-5.27 15.79-7.71.35-12.36 1.05c-.44-2.28 3.33-3.94 3.33-3.94a12.69 12.69 0 00-5.08-.36c-.27-2.54 3.24-3.85 3.24-3.85a8.69 8.69 0 00-3.77-.62c.09-3.77 7.8-2.45 7.8-2.45s-6.31-21.31 5.88-24.12c10.87-2.63 24.38 4.38 24.38 4.38z",
  fill: "url(#hero_svg__linear-gradient-142)"
});

var _ref333 = /*#__PURE__*/React.createElement("path", {
  d: "M742.23 476c2.37-10.61 12.54-16.75 12.54-16.75L769 467.7l-7.37 11s11.31 5.79 11.93 11.57-3.34 7.72-4.48 11.58c-3.15-1.05-1.66-4.65-1.66-4.65a12.58 12.58 0 00-3.95 4.39c-2.28-1.58-1.05-4.74-1.05-4.74a9.69 9.69 0 00-4.39 3.07c-2.19-3.68 3.42-8.07 3.42-8.07s-21.94-3.63-19.22-15.85z",
  fill: "url(#hero_svg__linear-gradient-143)"
});

var _ref334 = /*#__PURE__*/React.createElement("path", {
  d: "M746.79 443.05c4.91-10.7 25.08-7.36 23.77-1.84-3.07 12.81 2.28 16.49.17 26-1.93 8.86-7.45 11-10.17 13-6.49 4.91-16.75-5.26-19.65-13.59-2.63-7.81 3.25-17.63 5.88-23.51z",
  fill: "url(#hero_svg__linear-gradient-144)"
});

var _ref335 = /*#__PURE__*/React.createElement("path", {
  d: "M752.49 422.36c4.47-6.58-5.88-5.09-4.39-15.26a14.84 14.84 0 00-5.87 9c-.79 4.56-3.33 7.19-2.46 11.05.88 3.6 5.09 3.77 7.11 2.63 3.33-2.1 3.86-4.91 5.61-7.45z",
  fill: "url(#hero_svg__linear-gradient-145)"
});

var _ref336 = /*#__PURE__*/React.createElement("path", {
  d: "M751.26 413.85c5.7-4 19.38-2.37 25.61 10.17 2 4-5.88 1.32-2.81 10 4.48 12.72-24.2 15.26-30.52 11.84-.78-.44-4.38-6.14-3.24-9a13.69 13.69 0 01-.18-2.63c-2.1-1.49.09-4.3.88-5.18-1.14-3-.7-5 .26-6.58 1.23-2 7.55-6.92 10-8.59z",
  fill: "url(#hero_svg__linear-gradient-146)"
});

var _ref337 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hero_svg__clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-154",
  d: "M737.49 434.72c-.61-.61-1.57-1.66-1.31-2.54h.17a3.45 3.45 0 002.28 1.58.09.09 0 01.09.09l-1.05.78a.28.28 0 01-.18.09zm1.67 1.23a10.63 10.63 0 01-1-.79c-.09 0-.09-.09 0-.09l1.14-.87h.09l.08 1.66c-.13.14-.22.14-.31.14zm.7.18l-.09-1.76a.18.18 0 01.18-.17h.05c.17 0 .26.08.35.08a5.05 5.05 0 001.23.18h.08a.19.19 0 01.18.17.09.09 0 01-.09.09l-1.93 1.41c.18.08.09.08 0 0zm3.6 1.75a26.16 26.16 0 01-2.81-1.14c-.17-.09-.17-.18-.09-.35l.09-.09c.61-.44 1.93-1.4 2.28-1.67h.07l.88 2.9c0 .09-.09.26-.18.26-.18.18-.26.18-.26.09zm1 .17l-.88-3.06c0-.09.09-.27.18-.27h.09c.44 0 .79.09 1.14.09.7.09 1.4.09 2.1.18a.18.18 0 01.18.17.09.09 0 01-.09.09l-2.72 2.8zm3.77 1.14c-1-.17-1.84-.43-2.72-.61-.17 0-.26-.17-.17-.26a.09.09 0 01.09-.09l2.36-2.46h.09l.79 3.16a.23.23 0 01-.26.26zm1-.08h-.08l-.88-3.69a.23.23 0 01.26-.26h.09c.44.09.79.09 1.32.18l1.31.26a.28.28 0 01.27.26v.14l-2.28 3.16zm3.6.7c-.88-.09-1.75-.18-2.81-.35a.29.29 0 01-.26-.27v-.08l1.84-2.72h.09l1.32 3.07c.08.09 0 .26-.18.26.1.09.1.09.01.09zm1-.09l-1.58-3.59c-.08-.09 0-.18.18-.18h.09c.7.18 1.4.35 2 .53a7.32 7.32 0 011.23.35c.09 0 .18.17.18.17l-1.93 2.63c0 .09 0 .09-.11.09zm4.12.09a17.44 17.44 0 01-3 .09.24.24 0 01-.26-.27v-.08l1.75-2.46h.09c.26.35 1.14 1.75 1.58 2.37a.22.22 0 01-.18.35zm1.58-2l-.61 1.67h-.18l-1.31-2c-.09-.09 0-.17.09-.26h.26c.44.09.79.17 1.14.26.17 0 .26 0 .35.09s.26.17.26.26zm1.41 1.4a7.2 7.2 0 01-1.32.36c-.09 0-.17 0-.17-.09l.61-1.58h.17l.71 1.23c.08 0 .08.08 0 .08zm1.14-.52l-.53.26h-.09l-.7-1.14v-.09a4.79 4.79 0 001.67-.17 2.89 2.89 0 001-.53h.09a.33.33 0 01-.09.27c.11.5-.43.94-1.29 1.38z",
  id: "hero_svg__Teeth"
}));

var _ref338 = /*#__PURE__*/React.createElement("path", {
  d: "M792.92 415.52a.76.76 0 00-.53-.27 1.06 1.06 0 00-.52.09 27.44 27.44 0 01-13.42 3 10.07 10.07 0 00-3.51.35 5.85 5.85 0 00-2.19 1.41c-2.37 2.8-3.16 13.33 1.31 17.27a10.39 10.39 0 005.44.09l-.79-3 2.9 2a11 11 0 003.77-4.48l-1.93-1.84 2.72-.09a12.45 12.45 0 00.43-1.49c1.14-4.56 4.3-8.06 5.27-9.82a17.13 17.13 0 011.22-2.19 1 1 0 00-.17-1.05z",
  fill: "url(#hero_svg__linear-gradient-147)"
});

var _ref339 = /*#__PURE__*/React.createElement("path", {
  d: "M774.15 426.92c.7-1.23 1.58-3.07 6.05-4.12h.09a24.15 24.15 0 0012.8-6.14c-.17.35-1 1.75-1.22 2.19-1 1.75-4.13 5.26-5.27 9.82a12.45 12.45 0 01-.43 1.49l-2.72.09 1.93 1.84a10.9 10.9 0 01-3.77 4.47l-2.9-2 .79 3a9.51 9.51 0 01-5.44-.09 4.26 4.26 0 00-.17-1.05c-.44-3.1-1.14-7.22.26-9.5z",
  fill: "url(#hero_svg__linear-gradient-148)"
});

var _ref340 = /*#__PURE__*/React.createElement("path", {
  d: "M755.38 414.81c-.43-.35-2.45-.08-2.45-.08-.53.08-.79.44-.53.7a2.38 2.38 0 002.11.52c.96-.17 1.31-.78.87-1.14z",
  fill: "url(#hero_svg__linear-gradient-149)"
});

var _ref341 = /*#__PURE__*/React.createElement("path", {
  d: "M755.47 417c-1.14 0-.52 1.31.09 1.49s1.75-.18 1.58-.7c0-.43-1.05-.79-1.67-.79z",
  fill: "url(#hero_svg__linear-gradient-150)"
});

var _ref342 = /*#__PURE__*/React.createElement("path", {
  d: "M759.07 414.73c-.79-.18-1.84.87-1.93 1.31s.44.79 1.93 1 2.72-.43 2.72-.87-1.85-1.36-2.72-1.44z",
  fill: "url(#hero_svg__linear-gradient-151)"
});

var _ref343 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_w_mascot",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Brow_Eyes",
  "data-name": "Brow + Eyes"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-155",
  d: "M752.58 429.72a6.73 6.73 0 01-1.76-.7s1.23-.26 2.9-.7c4.56-1.23 7.71-3.42 10.08-3.07 1.41.18 1.58 2.19 1.58 2.19a6.82 6.82 0 00-2.28-.61 11.91 11.91 0 00-4.73 1.05"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-156",
  d: "M758.28 427.88a12.88 12.88 0 014.29 0 5.39 5.39 0 01-.26 1.67 4.66 4.66 0 01-5.35 3.33 5.26 5.26 0 01-4.38-3.07"
})));

var _ref344 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_w_mascot-2",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("path", {
  id: "hero_svg__Brow_Eyes-2",
  "data-name": "Brow + Eyes",
  className: "hero_svg__cls-157",
  d: "M756.7 429.11a10 10 0 013.24-.26 3.59 3.59 0 01-.17 1 2.67 2.67 0 01-3.16 1.93 3 3 0 01-2.54-1.84 7.69 7.69 0 012.63-.83z"
}));

var _ref345 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_w_mascot-3",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Brow_Eyes-3",
  "data-name": "Brow + Eyes"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-155",
  d: "M743.9 426.83a5.48 5.48 0 00-2.28-1.4 2 2 0 00-1.23.17s.35-1.4 1.05-1.4c1.23.09 2.54 2.1 4.74 3.59.78.53 1.66 1 1.75 1.06a4.75 4.75 0 01-1.4.08"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-156",
  d: "M746.61 429a2.53 2.53 0 01-2.63 1.67c-1.58-.18-2.28-1.67-2.28-3.16a5.67 5.67 0 01.09-1.23 5.1 5.1 0 012.19.53"
})));

var _ref346 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_w_mascot-4",
  "data-name": "b+w mascot"
}, /*#__PURE__*/React.createElement("path", {
  id: "hero_svg__Brow_Eyes-4",
  "data-name": "Brow + Eyes",
  className: "hero_svg__cls-157",
  d: "M744.6 428.14a5.66 5.66 0 00-1.49-.61c0 .18-.09.44-.09.61a1.44 1.44 0 001.23 1.58 1.47 1.47 0 001.49-.79 3.8 3.8 0 00-1.14-.79z"
}));

var _ref347 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-154",
  d: "M755.65 429.37s-1.49 0-1.67.62 2.19-.27 2.81-.35.08-.36-1.14-.27zm-11-1.23s.87.27.87.88-1.31-.61-1.57-.79-.14-.44.65-.09z"
});

var _ref348 = /*#__PURE__*/React.createElement("path", {
  d: "M726 405.61c.7-3.07 2.54-3.42 4.12-3.07 2.36-4.83 9.82 1.93 9.12 7.1-.7 5.35-3.77 21.22-.27 24.38 4.92 4.39 24 10.7 20.44 20.7-3.95 10.78-27.45-6.4-31.57-14.74-3.16-6.4.17-23.76-.27-27.18a3.88 3.88 0 00-5.26-3.16c.35-3.24 2.11-4 3.69-4z",
  fill: "url(#hero_svg__linear-gradient-152)"
});

var _ref349 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-153)",
  d: "M753.36 732.92l-114.38-66.77 74.04-42.74 114.38 66.77-74.04 42.74z"
});

var _ref350 = /*#__PURE__*/React.createElement("path", {
  d: "M744.8 639.31c.11 9.49-6.07 19-18.57 26.2-24.89 14.36-65.39 14.28-90.45-.19-12.47-7.2-18.77-16.61-18.89-26v-84H744.8z",
  fill: "url(#hero_svg__radial-gradient-3)"
});

var _ref351 = /*#__PURE__*/React.createElement("path", {
  d: "M756.08 620.89c.14 11.17-7.14 22.33-21.85 30.82-29.28 16.91-76.92 16.81-106.4-.21-14.68-8.5-22.09-19.5-22.22-30.61v-98.83h150.47z",
  fill: "url(#hero_svg__linear-gradient-154)"
});

var _ref352 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 680.85,
  cy: 522.06,
  rx: 43.44,
  ry: 75.24,
  transform: "rotate(-89.65 680.886 522.056)",
  fill: "url(#hero_svg__radial-gradient-4)"
});

var _ref353 = /*#__PURE__*/React.createElement("path", {
  d: "M754.38 531.58c-2.94 7.82-9.65 15.24-20.15 21.3-29.28 16.91-76.92 16.81-106.4-.21-8.74-5-14.9-11-18.49-17.35",
  stroke: "url(#hero_svg__linear-gradient-155)",
  strokeWidth: 2.58,
  strokeMiterlimit: 10,
  fill: "none"
});

var _ref354 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 680.85,
  cy: 521.31,
  rx: 32.38,
  ry: 57.18,
  transform: "rotate(-89.67 680.808 521.316)",
  fill: "url(#hero_svg__linear-gradient-156)"
});

var _ref355 = /*#__PURE__*/React.createElement("path", {
  d: "M640.55 544.12c22.41 12.69 58.62 12.76 80.87.16 7.86-4.45 12.92-9.89 15.2-15.62-2.31-5.83-7.46-11.37-15.48-15.92-22.41-12.68-58.62-12.76-80.87-.16-7.86 4.46-12.92 9.9-15.2 15.63 2.31 5.79 7.46 11.37 15.48 15.91z",
  fill: "url(#hero_svg__linear-gradient-157)"
});

var _ref356 = /*#__PURE__*/React.createElement("path", {
  d: "M652.91 205.7c-2.29-6.09-24.95-20.08-34.3-16.4a38.39 38.39 0 00-6.54 3.95l42.52 22.37z",
  fill: "url(#hero_svg__linear-gradient-158)"
});

var _ref357 = /*#__PURE__*/React.createElement("path", {
  d: "M663.12 210.33c-7.61-3-14.36-6.48-19.47-5.17S636.4 215 638 216.42c1.05 1 1.23-2.09 4.13-2.63-1.61 2.34 0 6.66 1.12 7.51s.36-3.89 3.23-4.27c-.32 3 1.94 5 2.71 4.58.57-.3-.82-3.56 2-4.3 2 2.05 11.4 10 16.78 6.26 5.19-3.58 2-10.46-4.83-13.24z",
  fill: "url(#hero_svg__linear-gradient-159)"
});

var _ref358 = /*#__PURE__*/React.createElement("path", {
  d: "M619.45 187.79c6.88 4.4 13.52 8 15.45 13 2.49 6.3-4.26 12-5.95 11.61-.81-.18.88-3.61-.52-5.27-.67 3.4-4.77 4.35-5.44 3.94s1.75-3.32.79-5.82c-2.29 2.28-6.37 1.63-6.43.77-.1-.7 4.47-2.22 3.41-4.31 0 0-14.68-3.52-14.84-10.06s7.34-7.94 13.53-3.86z",
  fill: "url(#hero_svg__linear-gradient-160)"
});

var _ref359 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-146",
  d: "M675 173.85a.69.69 0 00-.5.15 27 27 0 01-12.91 3.62 11.35 11.35 0 00-3.4.55 6.23 6.23 0 00-2 1.51c-2.6-3.72-7-5.84-13.08-6.29l-1.24-.12c-6.09-.44-10.76 1-13.92 4.34a5.33 5.33 0 00-1.84-1.79 10.47 10.47 0 00-3.35-1 26.61 26.61 0 01-12.2-5.51 1.13 1.13 0 00-.49-.18 1.35 1.35 0 00-.58.15.87.87 0 00-.29 1.06c.16.33.6 1.83.75 2.33.6 1.84 2.87 5.87 3 10.42a11.19 11.19 0 00.12 1.49l2.62.58-2.19 1.41a10.46 10.46 0 002.73 5l3.18-1.3-1.33 2.68a10 10 0 005.17 1 9.25 9.25 0 00-.51 3.12 5.34 5.34 0 001.93 4c1.6 1.53 4.2 2.69 8 3.64a2.44 2.44 0 011.44 1.53c.21 1 2.09 1.64 5.63 2h.26a17 17 0 004.63-.18 1.76 1.76 0 001.27-.86 2.42 2.42 0 011.69-1.27c4.14-.36 7-1.26 8.75-2.61a5.43 5.43 0 002.27-4v-.08c0-.91 0-1.81-.07-2.64a17.61 17.61 0 002.05.23l-.16-2.73 1.65 2.53.3-1.56 1.11 1.36a8.45 8.45 0 004-2.93l-2.88-2.81 3.92 1.2a11.65 11.65 0 001.43-3.51l-1.7-1a16.91 16.91 0 002-.18l-2.52-1.41 2.72.26c1.12-3.93 3.52-6.9 4.24-8.53.17-.41.88-1.79 1.05-2.11.09-.08.09-.25.1-.41a1 1 0 00-.79-1.18z"
});

var _ref360 = /*#__PURE__*/React.createElement("path", {
  d: "M675 173.85a.69.69 0 00-.5.15 27 27 0 01-12.91 3.62 11.35 11.35 0 00-3.4.55 6.23 6.23 0 00-2 1.51c-2.6-3.72-7-5.84-13.08-6.29l-1.24-.12c-6.09-.44-10.76 1-13.92 4.34a5.33 5.33 0 00-1.84-1.79 10.47 10.47 0 00-3.35-1 26.61 26.61 0 01-12.2-5.51 1.13 1.13 0 00-.49-.18 1.35 1.35 0 00-.58.15.87.87 0 00-.29 1.06c.16.33.6 1.83.75 2.33.6 1.84 2.87 5.87 3 10.42a11.19 11.19 0 00.12 1.49l2.62.58-2.19 1.41a10.46 10.46 0 002.73 5l3.18-1.3-1.33 2.68a10 10 0 005.17 1 9.25 9.25 0 00-.51 3.12 5.34 5.34 0 001.93 4c1.6 1.53 4.2 2.69 8 3.64a2.44 2.44 0 011.44 1.53c.21 1 2.09 1.64 5.63 2h.26a17 17 0 004.63-.18 1.76 1.76 0 001.27-.86 2.42 2.42 0 011.69-1.27c4.14-.36 7-1.26 8.75-2.61a5.43 5.43 0 002.27-4v-.08c0-.91 0-1.81-.07-2.64a17.61 17.61 0 002.05.23l-.16-2.73 1.65 2.53.3-1.56 1.11 1.36a8.45 8.45 0 004-2.93l-2.88-2.81 3.92 1.2a11.65 11.65 0 001.43-3.51l-1.7-1a16.91 16.91 0 002-.18l-2.52-1.41 2.72.26c1.12-3.93 3.52-6.9 4.24-8.53.17-.41.88-1.79 1.05-2.11.09-.08.09-.25.1-.41a1 1 0 00-.79-1.18z",
  fill: "url(#hero_svg__linear-gradient-161)"
});

var _ref361 = /*#__PURE__*/React.createElement("path", {
  d: "M665.29 181.37c-3.67 1.2-6.52 2.43-7.42 4.88s-.2 6 .28 9.09a4 4 0 01.13 1.08 11.85 11.85 0 002.06.31l-.16-2.73 1.65 2.53.3-1.56 1.11 1.36a8.37 8.37 0 004-2.93l-2.88-2.81 3.92 1.19a11.52 11.52 0 001.44-3.5l-1.71-1a16.72 16.72 0 002-.18l-2.51-1.41 2.71.26c1.12-3.93 3.53-6.9 4.24-8.53.18-.41.88-1.79 1.06-2.11-2.84 3.62-6.51 4.82-10.18 6z",
  fill: "url(#hero_svg__linear-gradient-162)"
});

var _ref362 = /*#__PURE__*/React.createElement("path", {
  d: "M643.74 176.39c.51-.32 2.72.17 2.72.17.49.09.81.52.55.76a2.84 2.84 0 01-2.31.25c-1.15-.28-1.46-.87-.96-1.18z",
  fill: "url(#hero_svg__linear-gradient-163)"
});

var _ref363 = /*#__PURE__*/React.createElement("path", {
  d: "M643.43 178.44c1.23.12.45 1.33-.3 1.48s-1.88-.4-1.7-.89 1.34-.69 2-.59z",
  fill: "url(#hero_svg__linear-gradient-164)"
});

var _ref364 = /*#__PURE__*/React.createElement("path", {
  d: "M639.63 175.84a2.51 2.51 0 012 1.47c.07.5-.6.72-2.17.84s-3-.76-2.94-1.17 2.2-1.09 3.11-1.14z",
  fill: "url(#hero_svg__linear-gradient-165)"
});

var _ref365 = /*#__PURE__*/React.createElement("path", {
  d: "M625.1 183.87c-.45-1.33-1-3.25-5-5.11h-.09a26.84 26.84 0 01-4.71-2.38 25.08 25.08 0 01-6.32-6.07c.15.34.6 1.84.75 2.34.6 1.83 2.86 5.87 3.05 10.41a10.88 10.88 0 00.11 1.49l2.63.58-2.2 1.42a10.59 10.59 0 002.73 5l3.18-1.31-1.23 2.65a9.74 9.74 0 005.25 1 4.31 4.31 0 01.36-1c.91-2.77 2.36-6.61 1.53-9z",
  fill: "url(#hero_svg__linear-gradient-166)"
});

var _ref366 = /*#__PURE__*/React.createElement("path", {
  d: "M652.21 195.31c-.21 1.4-1.22 2.11-3.86 1.94a4 4 0 01-1-.11c-2.8-.42-4-1-7.15-1.14s-4.37 0-7.18 0h-1c-2.63-.25-3.51-1.1-3.55-2.51-2.28 1.58.27 4.39 2.3 5.61s4.72 2 8.58 2.42h.83c3.87.2 6.69-.12 8.86-1s5.14-3.3 3.14-5.18z",
  fill: "url(#hero_svg__linear-gradient-167)"
});

var _ref367 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-154",
  d: "M629.37 197.22c-.64-.6-1.51-1.62-1.32-2.61 0-.08.09-.08.08 0a2.86 2.86 0 002.1 1.47c.09 0 .08.08 0 .08l-.86 1c.08.06 0 .06 0 .06zm1.53 1.2a4.09 4.09 0 01-1-.77c-.08 0-.07-.09 0-.17l.94-1.12h.16l.1 1.82c0 .25-.09.33-.17.24zm.66.1l-.19-2c0-.09.09-.25.18-.24h1.48c.17 0 .24.18.15.34l-1.54 1.76c0 .17-.08.08-.08.08zm3.17 1.51a22.8 22.8 0 01-2.53-.91c-.16-.09-.16-.25-.07-.41.51-.56 1.54-1.77 1.88-2.09h.08l.9 3.08c.07.17-.1.41-.26.32zm.9 0l-1-3.25a.24.24 0 01.25-.32c.33 0 .67-.06 1-.05.57 0 1.15-.05 1.81 0 .17 0 .24.18.16.34l-2.18 3.39c0-.08-.08-.08-.08-.08zm3.28.76a18.4 18.4 0 01-2.38-.4c-.16 0-.24-.26-.15-.42l1.91-3c0-.08.08 0 .08 0l.88 3.41c0 .25-.09.41-.34.4zm1-.21c0 .08-.09.08-.17 0l-1-3.91a.25.25 0 01.26-.32h1.16c.41 0 .74.1 1.15.12.16 0 .24.17.23.33l-1.6 3.75zm3.21.35a22.74 22.74 0 01-2.48 0c-.17 0-.33-.17-.24-.33l1.43-3.26c0-.08.08-.08.08 0l1.38 3.27c.08.19-.01.39-.17.39zm.83-.22l-1.61-3.71c-.08-.16.09-.32.17-.24a12.93 12.93 0 011.8.39c.33.09.74.11 1.07.2.16 0 .16.17.16.25l-1.54 3.14zm3.56-.38a19.12 19.12 0 01-2.58.49c-.16 0-.32-.17-.23-.33l1.41-2.85c0-.08.09-.08.08 0 .24.42 1.1 1.76 1.49 2.35a.23.23 0 01-.17.37zm1.23-2.35l-.47 1.88c0 .08-.09.08-.09 0l-1.25-2c-.08-.16 0-.33.17-.32h.09a4.8 4.8 0 001.07.12h.33c.16.09.24.17.15.34zm1.36 1.28a6.89 6.89 0 01-1.09.54c-.08 0-.16 0-.16-.09l.47-1.8c0-.08.09-.08.08 0l.7 1.26c.09.04.08.12 0 .12zm1-.63c-.16.08-.25.24-.42.32h-.08l-.71-1.09a.08.08 0 01.09-.08 4.85 4.85 0 001.41-.37 2.28 2.28 0 00.85-.71c0-.09.08 0 .08 0v.33a4.06 4.06 0 01-1.21 1.61z"
});

var _ref368 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-155",
  d: "M628.21 184.63c2.06.07 4.45 2.62 8.27 4.56 1.38.71 2.93 1.25 3.09 1.34a19.82 19.82 0 01-2.39.09 4.53 4.53 0 01-4.36 1.92 4.18 4.18 0 01-4.16-3.85 4.59 4.59 0 010-1.48 13.77 13.77 0 013.78.7 10.43 10.43 0 00-4-1.78 6.24 6.24 0 00-2.15.09c.08 0 .55-1.71 1.87-1.59zm26 3.56a11.29 11.29 0 00-4.24 1.11 11 11 0 013.8-.13 4.69 4.69 0 01-.21 1.48 4.26 4.26 0 01-4.73 3.15 4.77 4.77 0 01-4-2.61 11.92 11.92 0 01-2.29-.49c.25-.07 1.82-.35 3.32-.8 4.09-1.27 6.88-3.32 8.93-3.09 1.24.12 1.43 1.94 1.43 1.94a4.27 4.27 0 00-2-.56z"
});

var _ref369 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-156",
  d: "M649.85 189.29a10.81 10.81 0 013.8-.12 4.47 4.47 0 01-.22 1.48 4.25 4.25 0 01-4.72 3.15 4.77 4.77 0 01-4-2.61 21.82 21.82 0 005.14-1.9zm-12.59 1.25a4.51 4.51 0 01-4.35 1.92 4.25 4.25 0 01-4.17-3.85 4.33 4.33 0 010-1.48 13.68 13.68 0 013.77.7 22.56 22.56 0 004.7 2.71z"
});

var _ref370 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-157",
  d: "M635.6 191c.19-.74-4-2.19-4-2.19-1.3-.62-1.33.28-1.09.7s.84 2.1 2.15 2.39 2.73-.33 2.92-.9zm16.16.36a4.32 4.32 0 01-2.54 2c-1.33.2-2.62-.58-2.68-1.41s4.26-1.51 4.26-1.51c.66-.06 1.66-.2 1 .94z"
});

var _ref371 = /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-154",
  d: "M634.07 189.86s1.38.45 1.36 1.11-1.95-.88-2.52-1.15.01-.41 1.16.04zm14.15 1.2s-1.41.2-1.51.86 2.08-.6 2.66-.74 0-.42-1.15-.12z"
});

function SvgHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 970.4 732.93"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    id: "hero_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, /*#__PURE__*/React.createElement("path", {
    d: "M396.82 282.73l124.33 69.71a5 5 0 007.53-4.37v-77.3a15.09 15.09 0 00-7.53-13L396.82 188a5 5 0 00-7.52 4.37v77.3a15.21 15.21 0 007.52 13.05zM453.64 423l67.51 39a5 5 0 007.53-4.37v-77.3a15.09 15.09 0 00-7.53-13.05l-67.51-39a5 5 0 00-7.53 4.37v77.3a15.19 15.19 0 007.53 13z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.7,
    fill: "#f2f5fa"
  }), _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272, _ref273, _ref274, _ref275, _ref276, _ref277, _ref278, _ref279, _ref280, _ref281, _ref282, _ref283, _ref284, _ref285, _ref286, _ref287, _ref288, _ref289, _ref290, _ref291, _ref292, _ref293, _ref294, _ref295, _ref296, _ref297, _ref298, _ref299, _ref300, _ref301, _ref302, _ref303, _ref304, _ref305, _ref306, _ref307, _ref308, _ref309, _ref310, _ref311, _ref312, _ref313, _ref314, _ref315, _ref316, _ref317, _ref318, _ref319, _ref320, _ref321, _ref322, _ref323, _ref324, _ref325, _ref326, _ref327, _ref328, _ref329, _ref330, _ref331, _ref332, _ref333, _ref334, _ref335, _ref336, _ref337, _ref338, _ref339, _ref340, _ref341, _ref342, _ref343, _ref344, _ref345, _ref346, _ref347, _ref348, _ref349, _ref350, _ref351, _ref352, _ref353, _ref354, _ref355, _ref356, _ref357, _ref358, _ref359, _ref360, _ref361, _ref362, _ref363, _ref364, _ref365, _ref366, _ref367, _ref368, _ref369, _ref370, _ref371)));
}

export default __webpack_public_path__ + "static/hero.bb5abb96.svg";
export { SvgHero as ReactComponent };